/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';


// PAGINATION SUPPRIMÉE : Plus aucune fonction de pagination

function getNoResultsMessageLabel() {
    const filtersBlock = document.querySelector('.gt-campings-filtres[data-no-results-message]');
    const label = filtersBlock?.dataset?.noResultsMessage;

    if (typeof label === 'string' && label.trim() !== '') {
        return label;
    }

    return 'Aucun résultat ne correspond à votre recherche';
}

// Fonction utilitaire pour afficher/masquer le message "Aucun résultat"
function updateNoResultsMessage(visibleCount) {
    // Trouver le conteneur des campings
    const campingsContainer = document.querySelector('.gt-ws-ctv-campings-block, .wp-block-query[data-namespace="gt-ws-ctv-campings"]');
    if (!campingsContainer) {
        return;
    }
    
    // Chercher le message existant
    let noResultsMessage = campingsContainer.querySelector('.gt-ws-ctv-no-results-message');
    
    // Si aucun résultat et qu'il y a des filtres actifs
    if (visibleCount === 0) {
        // Vérifier s'il y a des filtres actifs
        let hasActiveFilters = false;
        document.querySelectorAll('.gt-campings-filtre').forEach(filterContainer => {
            const multiselect = filterContainer.querySelector('.gt-campings-filtre__multiselect');
            const select = filterContainer.querySelector('select.gt-campings-filtre__select');
            
            if (multiselect) {
                const checked = multiselect.querySelectorAll('input[type="checkbox"]:checked');
                if (checked.length > 0) {
                    hasActiveFilters = true;
                }
            } else if (select) {
                const selected = Array.from(select.selectedOptions).filter(opt => opt.value !== '');
                if (selected.length > 0) {
                    hasActiveFilters = true;
                }
            } else {
                const checked = filterContainer.querySelectorAll('input:checked:not([value=""])');
                if (checked.length > 0) {
                    hasActiveFilters = true;
                }
            }
        });
        
        // Afficher le message seulement s'il y a des filtres actifs
        if (hasActiveFilters) {
            if (!noResultsMessage) {
                // Créer le message
                noResultsMessage = document.createElement('div');
                noResultsMessage.className = 'gt-ws-ctv-no-results-message';
                noResultsMessage.textContent = getNoResultsMessageLabel();
                
                // Trouver le conteneur de la liste pour insérer le message
                const postTemplate = campingsContainer.querySelector('.wp-block-post-template, .gt-ws-ctv-campings-list');
                if (postTemplate) {
                    postTemplate.insertAdjacentElement('beforebegin', noResultsMessage);
                } else {
                    campingsContainer.appendChild(noResultsMessage);
                }
            }
            noResultsMessage.style.display = 'block';
        } else {
            // Masquer le message s'il n'y a pas de filtres actifs
            if (noResultsMessage) {
                noResultsMessage.style.display = 'none';
            }
        }
    } else {
        // Masquer le message s'il y a des résultats
        if (noResultsMessage) {
            noResultsMessage.style.display = 'none';
        }
    }
}

const { state } = store('gt/ctv', {
    actions: {
        // Fonction pour écouter les changements du formulaire de réservation
        listenToFormChanges: () => {
            // Écouter les changements sur les champs du formulaire de réservation
            const formContainer = document.querySelector('.gt-ws-ctv-form-resa');
            if (!formContainer) {
                return;
            }

            // Empêcher la soumission normale du formulaire
            const form = formContainer.querySelector('form');
            if (form) {
                form.addEventListener('submit', (e) => {
                    e.preventDefault();
                    store('gt/ctv').actions.filterCampingsByFormData();
                    return false;
                });
            }

            // Écouter les changements sur le champ région
            const regionSelect = formContainer.querySelector('select[name="accommodation_region"]');
            if (regionSelect) {
                regionSelect.addEventListener('change', (e) => {
                    e.preventDefault();
                    store('gt/ctv').actions.filterCampingsByFormData();
                });
            }

            // Écouter les changements sur le champ camping
            const campingSelect = formContainer.querySelector('select[name="accommodation_camping"]');
            if (campingSelect) {
                campingSelect.addEventListener('change', (e) => {
                    e.preventDefault();
                    store('gt/ctv').actions.filterCampingsByFormData();
                });
            }

            // Écouter les changements sur le champ type d'hébergement
            const typeSelect = formContainer.querySelector('select[name="accommodation_type"]');
            if (typeSelect) {
                typeSelect.addEventListener('change', (e) => {
                    e.preventDefault();
                    store('gt/ctv').actions.filterCampingsByFormData();
                });
            }

            // Écouter les changements sur le champ nombre de personnes
            const nbPersSelect = formContainer.querySelector('select[name="number_of_people"]');
            if (nbPersSelect) {
                nbPersSelect.addEventListener('change', (e) => {
                    e.preventDefault();
                    store('gt/ctv').actions.filterCampingsByFormData();
                });
            }

        },

        // Fonction pour filtrer les campings basée sur les données du formulaire
        filterCampingsByFormData: () => {
            const formContainer = document.querySelector('.gt-ws-ctv-form-resa');
            if (!formContainer) {
                return;
            }

            // Récupérer les valeurs du formulaire
            const formData = {
                region: '',
                camping: '',
                type: '',
                nbPers: '',
                arrival: '',
                departure: ''
            };

            // Récupérer la région sélectionnée
            const regionSelect = formContainer.querySelector('select[name="accommodation_region"]');
            if (regionSelect) {
                formData.region = regionSelect.value;
            }

            // Récupérer le camping sélectionné
            const campingSelect = formContainer.querySelector('select[name="accommodation_camping"]');
            if (campingSelect) {
                formData.camping = campingSelect.value;
            }

            // Récupérer le type d'hébergement sélectionné
            const typeSelect = formContainer.querySelector('select[name="accommodation_type"]');
            if (typeSelect) {
                formData.type = typeSelect.value;
            }

            // Récupérer le nombre de personnes
            const nbPersSelect = formContainer.querySelector('select[name="number_of_people"]');
            if (nbPersSelect) {
                formData.nbPers = nbPersSelect.value;
            }

            // Récupérer les dates
            const arrivalInput = formContainer.querySelector('input.gt-caleran-arrival, input.gt-caleran-merged');
            if (arrivalInput) {
                const dateValue = arrivalInput.value;
                if (dateValue.includes(' - ')) {
                    // Format fusionné : "14/10/2025 - 21/10/2025"
                    const dates = dateValue.split(' - ');
                    formData.arrival = dates[0];
                    formData.departure = dates[1];
                } else {
                    formData.arrival = dateValue;
                }
            }

            const departureInput = formContainer.querySelector('input.gt-caleran-departure');
            if (departureInput) {
                formData.departure = departureInput.value;
            }


            // Mettre à jour l'URL sans recharger la page
            const url = new URL(window.location);
            
            // Ajouter ou mettre à jour les paramètres
            if (formData.arrival) url.searchParams.set('arrival', formData.arrival);
            if (formData.departure) url.searchParams.set('departure', formData.departure);
            if (formData.nbPers) url.searchParams.set('nbPers', formData.nbPers);
            
            // Gérer le paramètre région : l'ajouter s'il a une valeur, le supprimer s'il est vide
            if (formData.region) {
                url.searchParams.set('region', formData.region);
            } else {
                url.searchParams.delete('region');
            }
            
            if (formData.camping) url.searchParams.set('idCamping', formData.camping);
            if (formData.type) url.searchParams.set('type', formData.type);

                   // Mettre à jour l'URL dans l'historique du navigateur
                   window.history.pushState({}, '', url);

                   // Déclencher le filtrage AJAX
                   store('gt/ctv').actions.filterCampingsByAjax(formData);
        },
        runFilters: (e) => {
            const ctv = store("gt/ctv");
        
            // Toujours exécuter la logique de filtrage, même sans événement
            // (pour permettre l'appel manuel depuis toggleMultiselectOption)
            if (e !== undefined && e.type !== "load" && (e.type === "change" || e.type === "click")) {
                // Find the container of the clicked filter
                let filterContainer = e.target?.closest('.gt-campings-filtre');
        
                // Check if it's a multiselect, select, or checkbox
                let multiselect = filterContainer.querySelector('.gt-campings-filtre__multiselect');
                let select = filterContainer.querySelector('select.gt-campings-filtre__select');
                
                if (multiselect) {
                    // For multiselect dropdown, get all checked values
                    let checkedOptions = Array.from(multiselect.querySelectorAll('input[type="checkbox"]:checked'))
                        .map(checkbox => checkbox.value);
                    
                    let cookieName = filterContainer.getAttribute('data-gt-cookie');
                    if (cookieName) {
                        Cookies.set(cookieName, checkedOptions);
                    }
                } else if (select) {
                    // For select multiple, handle "Tous" option logic
                    let tousOption = select.querySelector('option[value=""]');
                    let selectedOptions = Array.from(select.selectedOptions).map(option => option.value);
                    
                    // If "Tous" was just selected, deselect all other options
                    if (tousOption && tousOption.selected && selectedOptions.length > 1) {
                        Array.from(select.options).forEach(option => {
                            if (option.value !== '') option.selected = false;
                        });
                        selectedOptions = [''];
                    }
                    // If any other option is selected, deselect "Tous"
                    else if (selectedOptions.length > 0 && selectedOptions.some(val => val !== '')) {
                        if (tousOption) tousOption.selected = false;
                        selectedOptions = selectedOptions.filter(val => val !== '');
                    }
                    
                    let cookieName = filterContainer.getAttribute('data-gt-cookie');
                    if (cookieName) {
                        let cookieValue = selectedOptions.filter(val => val !== '');
                        Cookies.set(cookieName, cookieValue);
                    }
                } else {
                    // Check/uncheck "All" checkbox based on individual selections
                    let allCheckbox = filterContainer.querySelector('input[value=""]');
                    let allChecked = filterContainer.querySelectorAll('input:checked:not([value=""])');
                    if (allCheckbox) {
                        allCheckbox.checked = allChecked.length === 0;
                    }
        
                    // Store selected filter values in cookies and ctv state
                    let cookieName = filterContainer.getAttribute('data-gt-cookie');
                    if (cookieName) {
                        let cookieValue = Array.from(allChecked).map(checkbox => checkbox.value);
                        Cookies.set(cookieName, cookieValue);
                        // ctv.state[cookieName] = cookieValue;
                    }
                }
            }
            
            // Vérifier s'il y a une région sélectionnée dans le formulaire
            let regionFromForm = '';
            const formContainer = document.querySelector('.gt-ws-ctv-form-resa');
            if (formContainer) {
                const regionSelect = formContainer.querySelector('select[name="accommodation_region"]');
                if (regionSelect && regionSelect.value) {
                    regionFromForm = regionSelect.value;
                }
            }
            
            // Fonction utilitaire pour vérifier la correspondance de région
            const checkRegionMatch = (campingText, regionText) => {
                const campingLower = campingText.toLowerCase();
                const regionLower = regionText.toLowerCase();
                
                // Correspondance générale simplifiée
                return campingLower.includes(regionLower);
            };
        
            // Initialize the filters object and count of active filters
            let filters = {};
            let activeFilterCount = 0;
            
            // Debug: Log au début pour voir quels filtres sont collectés
            console.log('DEBUG RUNFILTERS - Début de la collecte des filtres');
        
            // Loop over all active filters and collect the checked/selected values
            document.querySelectorAll('.gt-campings-filtre').forEach(activeFilterContainer => {
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                let operator = activeFilterContainer.getAttribute('data-gt-filtre-operator') || 'OR'; // Default to "OR" operator
                // Normaliser l'opérateur (enlever les espaces, mettre en majuscules)
                operator = operator ? operator.trim().toUpperCase() : 'OR';
        
                if (filterName) {
                    let selectedValues = [];
                    
                    // Check if it's a multiselect dropdown or regular checkbox
                    let multiselect = activeFilterContainer.querySelector('.gt-campings-filtre__multiselect');
                    let select = activeFilterContainer.querySelector('select.gt-campings-filtre__select');
                    
                    if (multiselect) {
                        // For multiselect dropdown, get all checked values
                        selectedValues = Array.from(multiselect.querySelectorAll('input[type="checkbox"]:checked'))
                            .map(checkbox => checkbox.value);
                    } else if (select) {
                        // For select multiple, get all selected values (excluding "Tous")
                        selectedValues = Array.from(select.selectedOptions)
                            .map(option => option.value)
                            .filter(val => val !== '');
                    } else {
                        // For checkboxes, get all checked values
                        selectedValues = Array.from(activeFilterContainer.querySelectorAll('input:checked:not([value=""])'))
                            .map(input => input.value);
                    }
        
                    // Only add filters with selected values to the filters object
                    if (selectedValues.length > 0) {
                        filters[filterName] = {
                            values: selectedValues,
                            operator: operator
                        };
                        activeFilterCount++; // Count active filters with at least one checked value
                    }
                }
            });

            // Debug: Log après la collecte des filtres
            console.log('DEBUG RUNFILTERS - Filtres collectés:', filters, 'Nombre de filtres actifs:', activeFilterCount);

            // Si aucun filtre n'est actif, afficher tous les campings (ou ceux de la région si une région est sélectionnée)
            if (activeFilterCount === 0) {
                
                // Collecter tous les IDs de campings visibles
                let allVisibleCampingsIds = [];
                let visibleCount = 0;
                
                document.querySelectorAll('.wp-block-query .wp-block-post, .wp-block-query .camping, .gt-ws-ctv-campings-block .wp-block-post, .gt-ws-ctv-campings-block .camping, .gt-ws-ctv-campings-block .wp-block-post-template li').forEach(camping => {
                    let shouldShow = true;
                    
                    // Vérifier la région si elle est définie
                    if (regionFromForm) {
                        // Utiliser les données de la carte qui fonctionnent déjà
                        let campingId = camping.getAttribute('data-gt-camping') || 
                                      camping.getAttribute('data-gt-camping-id') ||
                                      camping.getAttribute('data-post-id') ||
                                      camping.className.match(/post-(\d+)/)?.[1];
                        
                        // Si visibleCampingsIds est vide, afficher tous les campings
                        // Sinon, afficher seulement ceux dans la liste (filtrés par région)
                        if (state.visibleCampingsIds && state.visibleCampingsIds.length > 0) {
                            shouldShow = campingId && state.visibleCampingsIds.includes(campingId.toString());
                        }
                    }
                    
                    if (shouldShow) {
                        let campingId = camping.getAttribute('data-gt-camping') || 
                                      camping.getAttribute('data-gt-camping-id') ||
                                      camping.getAttribute('data-post-id') ||
                                      camping.className.match(/post-(\d+)/)?.[1];
                        if (campingId) {
                            allVisibleCampingsIds.push(campingId.toString());
                        }
                        visibleCount++;
                        
                        // Afficher le camping
                        camping.classList.remove('gt-ws-ctv-hidden');
                        camping.classList.add('gt-ws-ctv-visible');
                        camping.style.display = '';
                    } else {
                        // Masquer le camping et mettre à jour les classes CSS
                        camping.classList.remove('gt-ws-ctv-visible');
                        camping.classList.add('gt-ws-ctv-hidden');
                        camping.style.display = 'none';
                    }
                });
                
                // Si aucune région n'est sélectionnée, réinitialiser visibleCampingsIds pour afficher tous les marqueurs
                if (!regionFromForm) {
                    state.visibleCampingsIds = [];
                } else {
                    // Si une région est sélectionnée, garder les IDs de la région
                    // (state.visibleCampingsIds reste inchangé car il contient déjà les IDs de la région)
                }
                
                // Mettre à jour l'attribut data-has-filters pour indiquer qu'il n'y a pas de filtres
                const campingsContainer = document.querySelector('.gt-ws-ctv-campings-block, .wp-block-query[data-namespace="gt-ws-ctv-campings"]');
                if (campingsContainer) {
                    campingsContainer.removeAttribute('data-filtered-camping-ids');
                    campingsContainer.setAttribute('data-has-filters', 'false');
                }
                
                // Afficher tous les campings visibles
                setTimeout(() => {
                    // Afficher tous les campings visibles
                    const $list = jQuery('.gt-ws-ctv-campings-list, .wp-block-post-template').first();
                    if ($list.length > 0) {
                        const $allItems = $list.find('li.wp-block-post');
                        // Afficher tous les éléments visibles
                        $allItems.each(function() {
                            const $item = jQuery(this);
                            
                            // Si l'élément n'est pas masqué par les filtres, l'afficher
                            if (!$item.hasClass('gt-ws-ctv-hidden') || $item.hasClass('gt-ws-ctv-visible')) {
                                $item.addClass('gt-ws-ctv-visible').show();
                            }
                        });
                    }
                    
                    // PAGINATION SUPPRIMÉE
                }, 100);
                
                // Mettre à jour le message d'absence de résultats
                updateNoResultsMessage(visibleCount);
                
                // Mettre à jour la carte
                if (store('gt/ctv')?.actions?.updateMap) {
                    store('gt/ctv').actions.updateMap();
                }
                return;
            }

            // Vérifier si tous les filtres ont la case "Tous" cochée ou le select sur "Tous"
            let allFiltersHaveAllSelected = true;
            document.querySelectorAll('.gt-campings-filtre').forEach(activeFilterContainer => {
                let multiselect = activeFilterContainer.querySelector('.gt-campings-filtre__multiselect');
                let select = activeFilterContainer.querySelector('select.gt-campings-filtre__select');
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                
                if (multiselect) {
                    // For multiselect dropdown, check if any options are checked
                    let checkedOptions = multiselect.querySelectorAll('input[type="checkbox"]:checked');
                    if (checkedOptions.length > 0) {
                        allFiltersHaveAllSelected = false;
                    }
                } else if (select) {
                    // For select multiple, check if "Tous" is selected or no options are selected
                    let selectedOptions = Array.from(select.selectedOptions).map(option => option.value);
                    if (selectedOptions.length > 0 && !selectedOptions.includes('')) {
                        allFiltersHaveAllSelected = false;
                    }
                } else {
                    // For checkboxes, check if "Tous" is checked
                    let allCheckbox = activeFilterContainer.querySelector('input[value=""]');
                    if (allCheckbox && !allCheckbox.checked) {
                        allFiltersHaveAllSelected = false;
                    }
                }
            });
            

            if (allFiltersHaveAllSelected) {
                
                // Collecter tous les IDs de campings visibles
                let allVisibleCampingsIds = [];
                let visibleCount = 0;
                
                document.querySelectorAll('.wp-block-query .wp-block-post, .wp-block-query .camping, .gt-ws-ctv-campings-block .wp-block-post, .gt-ws-ctv-campings-block .camping, .gt-ws-ctv-campings-block .wp-block-post-template li').forEach(camping => {
                    let shouldShow = true;
                    
                    // Vérifier la région si elle est définie
                    if (regionFromForm) {
                        // Utiliser les données de la carte qui fonctionnent déjà
                        let campingId = camping.getAttribute('data-gt-camping') || 
                                      camping.getAttribute('data-gt-camping-id') ||
                                      camping.getAttribute('data-post-id') ||
                                      camping.className.match(/post-(\d+)/)?.[1];
                        
                        // Si visibleCampingsIds est vide, afficher tous les campings
                        // Sinon, afficher seulement ceux dans la liste (filtrés par région)
                        if (state.visibleCampingsIds && state.visibleCampingsIds.length > 0) {
                            shouldShow = campingId && state.visibleCampingsIds.includes(campingId.toString());
                        }
                    }
                    
                    if (shouldShow) {
                        let campingId = camping.getAttribute('data-gt-camping') || 
                                      camping.getAttribute('data-gt-camping-id') ||
                                      camping.getAttribute('data-post-id') ||
                                      camping.className.match(/post-(\d+)/)?.[1];
                        if (campingId) {
                            allVisibleCampingsIds.push(campingId.toString());
                        }
                        visibleCount++;
                        
                        // Afficher le camping
                        camping.classList.remove('gt-ws-ctv-hidden');
                        camping.classList.add('gt-ws-ctv-visible');
                        camping.style.display = '';
                    } else {
                        // Masquer le camping et mettre à jour les classes CSS
                        camping.classList.remove('gt-ws-ctv-visible');
                        camping.classList.add('gt-ws-ctv-hidden');
                        camping.style.display = 'none';
                    }
                });
                
                // Si aucune région n'est sélectionnée, réinitialiser visibleCampingsIds pour afficher tous les marqueurs
                if (!regionFromForm) {
                    state.visibleCampingsIds = [];
                } else {
                    // Si une région est sélectionnée, garder les IDs de la région
                    // (state.visibleCampingsIds reste inchangé car il contient déjà les IDs de la région)
                }
                
                // Mettre à jour l'attribut data-has-filters pour indiquer qu'il n'y a pas de filtres
                const campingsContainer = document.querySelector('.gt-ws-ctv-campings-block, .wp-block-query[data-namespace="gt-ws-ctv-campings"]');
                if (campingsContainer) {
                    campingsContainer.removeAttribute('data-filtered-camping-ids');
                    campingsContainer.setAttribute('data-has-filters', 'false');
                }
                
                // Afficher tous les campings visibles
                setTimeout(() => {
                    // Afficher tous les campings visibles
                    const $list = jQuery('.gt-ws-ctv-campings-list, .wp-block-post-template').first();
                    if ($list.length > 0) {
                        const $allItems = $list.find('li.wp-block-post');
                        // Afficher tous les éléments visibles
                        $allItems.each(function() {
                            const $item = jQuery(this);
                            
                            // Si l'élément n'est pas masqué par les filtres, l'afficher
                            if (!$item.hasClass('gt-ws-ctv-hidden') || $item.hasClass('gt-ws-ctv-visible')) {
                                $item.addClass('gt-ws-ctv-visible').show();
                            }
                        });
                    }
                    
                    // PAGINATION SUPPRIMÉE
                }, 100);
                
                // Mettre à jour le message d'absence de résultats
                updateNoResultsMessage(visibleCount);
                
                // Mettre à jour la carte
                if (store('gt/ctv')?.actions?.updateMap) {
                    store('gt/ctv').actions.updateMap();
                }
                return;
            }

            // Count active filters (checkboxes, selects, or multiselects with value)
            let activeCount = 0;
            document.querySelectorAll('.gt-campings-filtre').forEach(filterContainer => {
                let multiselect = filterContainer.querySelector('.gt-campings-filtre__multiselect');
                let select = filterContainer.querySelector('select.gt-campings-filtre__select');
                
                    if (multiselect) {
                        // For multiselect dropdown, count checked options
                        activeCount += multiselect.querySelectorAll('input[type="checkbox"]:checked').length;
                } else if (select) {
                    // For select multiple, count selected options (excluding "Tous")
                    let selectedOptions = Array.from(select.selectedOptions)
                        .map(option => option.value)
                        .filter(val => val !== '');
                    activeCount += selectedOptions.length;
                } else {
                    activeCount += filterContainer.querySelectorAll('input:checked:not([value=""])').length;
                }
            });
            state.activeCheckboxes = activeCount;
        
        
            // Hide/show each camping based on the selected filters
            let visibleCampings = [];
            let visibleCampingsIds = [];
            // Essayer plusieurs sélecteurs pour trouver les campings
            let allCampings = document.querySelectorAll('.wp-block-query .wp-block-post, .wp-block-query .camping, .wp-block-query li[class*="post-"], .gt-ws-ctv-campings-block .wp-block-post, .gt-ws-ctv-campings-block .camping, .gt-ws-ctv-campings-block li[class*="post-"], .gt-ws-ctv-campings-block .wp-block-post-template li');
            
            console.log('DEBUG RUNFILTERS - Nombre de campings trouvés:', allCampings.length);
            
            // Si aucun camping n'est trouvé, essayer d'autres sélecteurs
            if (allCampings.length === 0) {
                console.warn('DEBUG: Aucun camping trouvé avec les sélecteurs standards, essai avec d\'autres sélecteurs...');
                const altCampings = document.querySelectorAll('li[class*="post-"], .wp-block-post-template li, [data-gt-camping]');
                if (altCampings.length > 0) {
                    allCampings = altCampings;
                    console.log('DEBUG RUNFILTERS - Campings trouvés avec sélecteurs alternatifs:', allCampings.length);
                }
            }
            
            
            allCampings.forEach((camping, index) => {
                let shouldShow = true;
                
                // Trouver l'élément <li> qui contient les attributs data
                // Les attributs data-gt-* sont toujours sur le <li>
                let campingElement = camping;
                
                // Si camping n'est pas déjà un <li>, chercher le <li> parent
                if (camping.tagName !== 'LI') {
                    campingElement = camping.closest('li');
                    // Si toujours pas trouvé, utiliser camping lui-même
                    if (!campingElement) {
                        campingElement = camping;
                    }
                }
                
                // Vérifier que campingElement a bien les attributs, sinon chercher le <li> parent
                if (!campingElement.getAttribute('data-gt-camping') && campingElement.tagName !== 'LI') {
                    const parentLi = campingElement.closest('li');
                    if (parentLi && parentLi.getAttribute('data-gt-camping')) {
                        campingElement = parentLi;
                    }
                }
                
                let campingName = camping.querySelector('h1, h2, h3, .wp-block-post-title')?.textContent || `Camping ${index + 1}`;
                 
                // Debug: Vérifier si c'est le camping des Pins
                let campingText = camping.textContent;
                
                // Vérifier d'abord la région si elle est définie
                if (regionFromForm) {
                    // Utiliser les données de la carte qui fonctionnent déjà
                    // IMPORTANT: data-gt-camping contient le campingKey/idSite qui correspond à state.campings[].idSite
                    let campingId = campingElement.getAttribute('data-gt-camping') || 
                                  campingElement.getAttribute('data-gt-camping-id') ||
                                  campingElement.getAttribute('data-post-id') ||
                                  campingElement.className.match(/post-(\d+)/)?.[1] ||
                                  camping.className.match(/post-(\d+)/)?.[1];
                    
                    // Si visibleCampingsIds est vide, afficher tous les campings
                    // Sinon, afficher seulement ceux dans la liste (filtrés par région)
                    let regionMatches = true;
                    if (state.visibleCampingsIds && state.visibleCampingsIds.length > 0) {
                        // Comparer en string pour être sûr
                        const campingIdStr = campingId ? campingId.toString() : '';
                        regionMatches = campingIdStr && state.visibleCampingsIds.some(id => id.toString() === campingIdStr);
                    }
                
                    
                    if (!regionMatches) {
                        shouldShow = false;
                        
                    }
                }
             
                // Check each filter against the data attributes of the camping
                // Seulement si le camping correspond à la région (ou s'il n'y a pas de région)
                if (shouldShow) {
                    // Utiliser une boucle for...of pour pouvoir utiliser break
                    for (const filterName of Object.keys(filters)) {
                        // Si shouldShow est déjà false, sortir de la boucle
                        if (!shouldShow) break;
                        
                        let dataAttributeValue = campingElement.getAttribute(`data-gt-${filterName}`);
                    
                        // Pour les filtres de critères (piscine, service, activites), utiliser data-gt-criterion
                        if (filterName === 'piscine' || filterName === 'service' || filterName === 'activites') {
                            dataAttributeValue = campingElement.getAttribute('data-gt-criterion');
                        }
                
                        // Gérer le cas où l'attribut n'existe pas ou est vide
                        if (!dataAttributeValue || dataAttributeValue === '' || dataAttributeValue === '[]') {
                            // Si le filtre est activé (au moins une valeur sélectionnée), masquer le camping
                            if (filters[filterName].values && filters[filterName].values.length > 0) {
                                shouldShow = false;
                                break; // Sortir de la boucle for...of
                            }
                            // Si le filtre n'est pas activé, passer au filtre suivant
                            continue;
                        }
                    
                        // Traiter le filtre si dataAttributeValue n'est pas vide
                        let dataAttribute;
                        try {
                            dataAttribute = JSON.parse(dataAttributeValue);
                        } catch (e) {
                            // Si ce n'est pas du JSON, traiter comme une chaîne simple
                            dataAttribute = dataAttributeValue;
                        }
        
                        if (dataAttribute) {
                        // Convert the data-attribute value into an array if it's a string
                        let filter = filters[filterName];
                        let { values, operator } = filter;
        
                        let matches = false;
                        // Normaliser l'opérateur pour la comparaison (enlever les espaces, mettre en majuscules)
                        operator = operator ? operator.trim().toUpperCase() : 'OR';
                        // Debug: Log pour voir l'opérateur utilisé
                        console.log('DEBUG FILTRE - filterName:', filterName, 'operator:', operator, 'values:', values);
                        switch (operator) {
                            case 'AND':
                                // Pour AND, toutes les valeurs sélectionnées doivent être présentes dans dataAttribute
                                
                                // Pour les filtres de critères (piscine, service, activites), utiliser data-gt-criterion
                                if (filterName === 'piscine' || filterName === 'service' || filterName === 'activites') {
                                    try {
                                        let criterion_mykeys = [];
                                        
                                        // Utiliser data-gt-criterion pour tous ces filtres
                                        const criterionAttr = campingElement.getAttribute('data-gt-criterion');
                                        
                                        if (criterionAttr && criterionAttr !== '[]') {
                                            try {
                                                criterion_mykeys = JSON.parse(criterionAttr);
                                                if (!Array.isArray(criterion_mykeys)) {
                                                    criterion_mykeys = [];
                                                }
                                                // Convertir en strings pour la comparaison
                                                criterion_mykeys = criterion_mykeys.map(k => String(k));
                                            } catch (parseError) {
                                                console.warn(`Erreur parsing data-gt-criterion pour camping ${index + 1}:`, parseError, 'Raw value:', criterionAttr);
                                            }
                                        }
                                        
                                        // Convertir les valeurs sélectionnées en strings pour la comparaison
                                        const selectedMyKeys = values.map(v => String(v));
                                        
                                        // Pour AND, toutes les valeurs sélectionnées doivent être présentes dans criterion_mykeys
                                        matches = selectedMyKeys.every(selectedKey => {
                                            const found = criterion_mykeys.includes(selectedKey);
                                            console.log(`DEBUG AND - filterName: ${filterName}, selectedKey: ${selectedKey}, found: ${found}, criterion_mykeys:`, criterion_mykeys);
                                            return found;
                                        });
                                        
                                        console.log(`DEBUG AND - filterName: ${filterName}, selectedMyKeys:`, selectedMyKeys, 'criterion_mykeys:', criterion_mykeys, 'matches:', matches);
                                        
                                    } catch (e) {
                                        console.error(`Erreur lors du filtrage par ${filterName} pour le camping ${index + 1}:`, e);
                                        matches = false; // En cas d'erreur, ne pas afficher le camping
                                    }
                                } else {
                                    // Pour les autres filtres (department, etoiles), utiliser dataAttribute normal
                                    // Convertir dataAttribute en tableau si nécessaire
                                    let dataValuesAND;
                                    if (Array.isArray(dataAttribute)) {
                                        dataValuesAND = dataAttribute;
                                    } else if (typeof dataAttribute === 'string') {
                                        // Essayer de parser comme JSON d'abord
                                        try {
                                            dataValuesAND = JSON.parse(dataAttribute);
                                        } catch (e) {
                                            dataValuesAND = dataAttribute.includes(',') ? dataAttribute.split(',') : [dataAttribute];
                                        }
                                    } else {
                                        dataValuesAND = [dataAttribute];
                                    }
                                    
                                    // Vérifier que toutes les valeurs sélectionnées sont présentes dans dataValuesAND
                                    matches = values.every(value => dataValuesAND.map(String).includes(String(value)));
                                }
                                
                            
                                break;
                            

                            case '<=':
                                // Match if all dataValues are less than or equal to filter values (assuming numerical comparison)
                                matches = values.every(value => parseInt(dataValues[0]) <= parseInt(value));
                                break;
                            case '>=':
                                // Match if all dataValues are greater than or equal to filter values (assuming numerical comparison)
                                matches = values.every(value => parseInt(dataValues[0]) >= parseInt(value));
                                break;
                            case 'OR':
                            default:
                                // Match if any filter value is present in dataValues (default behavior)
                                // Convertir dataAttribute en tableau si nécessaire
                                let dataValuesOR;
                                if (Array.isArray(dataAttribute)) {
                                    dataValuesOR = dataAttribute;
                                } else if (typeof dataAttribute === 'string') {
                                    dataValuesOR = dataAttribute.includes(',') ? dataAttribute.split(',') : [dataAttribute];
                                } else {
                                    dataValuesOR = [dataAttribute];
                                }
                                
                                // Fonction de normalisation pour la comparaison (insensible à la casse et aux espaces)
                                const normalizeForComparison = (str) => {
                                    if (!str) return '';
                                    return String(str).trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
                                };
                                
                                // Pour le filtre "department", utiliser une comparaison normalisée
                                if (filterName === 'department') {
                                    // Les valeurs sont déjà normalisées en PHP, donc essayer d'abord une comparaison exacte
                                    // Puis utiliser la normalisation JavaScript si nécessaire
                                    
                                    // Comparaison exacte d'abord (les valeurs sont déjà normalisées en PHP)
                                    // Comparer en normalisant les espaces et en ignorant la casse
                                    let exactMatch = values.some(value => {
                                        const valueStr = String(value).trim().toLowerCase();
                                        return dataValuesOR.some(dv => {
                                            const dvStr = String(dv).trim().toLowerCase();
                                            return dvStr === valueStr;
                                        });
                                    });
                                    
                                    // Si pas de correspondance exacte, essayer avec normalisation JavaScript
                                    if (!exactMatch) {
                                        const normalizedValues = values.map(v => normalizeForComparison(v));
                                        const normalizedDataValues = dataValuesOR.map(v => normalizeForComparison(v));
                                        
                                        
                                        // Vérifier chaque valeur individuellement pour le débogage
                                        normalizedValues.forEach((nv, idx) => {
                                            const found = normalizedDataValues.includes(nv);
                                        });
                                        
                                        matches = normalizedValues.some(value => normalizedDataValues.includes(value));
                                    } else {
                                        matches = true;
                                        // Debug pour les correspondances exactes
                                        
                                    }
                                    
                                } else if (filterName === 'etoiles') {
                                    // Pour le filtre "etoiles", utiliser une comparaison numérique stricte
                                    // IMPORTANT: Utiliser directement dataAttributeValue (valeur brute) au lieu de dataValuesOR
                                    // pour éviter les problèmes de parsing JSON
                                    
                                    // Convertir les valeurs du filtre en nombres pour la comparaison
                                    const numericValues = values.map(v => {
                                        const num = parseInt(String(v).trim(), 10);
                                        return isNaN(num) ? null : num;
                                    }).filter(v => v !== null);
                                    
                                    // Convertir directement la valeur brute de l'attribut en nombre
                                    // (sans passer par dataValuesOR qui peut avoir été mal parsé)
                                    let numericDataValue = null;
                                    if (dataAttributeValue) {
                                        const trimmedValue = String(dataAttributeValue).trim();
                                        numericDataValue = parseInt(trimmedValue, 10);
                                        if (isNaN(numericDataValue)) {
                                            numericDataValue = null;
                                        }
                                    }
                                    
                                    // Vérifier que nous avons des valeurs numériques valides
                                    if (numericValues.length === 0 || numericDataValue === null) {
                                        matches = false;
                                        console.log('DEBUG FILTRE ETOILES - Valeurs invalides:', {
                                            campingName: campingName,
                                            filterValues: numericValues,
                                            campingEtoiles: numericDataValue,
                                            dataAttributeValue: dataAttributeValue
                                        });
                                    } else {
                                        // Match si le nombre d'étoiles du camping correspond exactement à l'une des valeurs sélectionnées
                                        // IMPORTANT: Vérifier si la valeur du camping est dans les valeurs du filtre
                                        matches = numericValues.includes(numericDataValue);
                                        
                                        // Debug: Log pour TOUS les cas (correspondance ou non)
                                        if (!matches) {
                                            console.log('DEBUG FILTRE ETOILES - Pas de correspondance:', {
                                                campingName: campingName,
                                                filterValues: numericValues,
                                                campingEtoiles: numericDataValue,
                                                matches: matches,
                                                dataAttributeValue: dataAttributeValue,
                                                shouldShow: shouldShow
                                            });
                                        } else {
                                            console.log('DEBUG FILTRE ETOILES - Correspondance trouvée:', {
                                                campingName: campingName,
                                                filterValues: numericValues,
                                                campingEtoiles: numericDataValue,
                                                matches: matches
                                            });
                                        }
                                    }
                                  
                                } else if (filterName === 'piscine' || filterName === 'service' || filterName === 'activites') {
                                    // Pour les filtres de critères (piscine, service, activites), utiliser data-gt-criterion
                                    try {
                                        let criterion_mykeys = [];
                                        
                                        // Utiliser data-gt-criterion pour tous ces filtres
                                        const criterionAttr = campingElement.getAttribute('data-gt-criterion');
                                        
                                        
                                        if (criterionAttr && criterionAttr !== '[]') {
                                            try {
                                                criterion_mykeys = JSON.parse(criterionAttr);
                                                if (!Array.isArray(criterion_mykeys)) {
                                                    criterion_mykeys = [];
                                                }
                                                // Convertir en strings pour la comparaison
                                                criterion_mykeys = criterion_mykeys.map(k => String(k));
                                            } catch (parseError) {
                                                console.warn(`Erreur parsing data-gt-criterion pour camping ${index + 1}:`, parseError, 'Raw value:', criterionAttr);
                                            }
                                        }
                                        
                                        // Convertir les valeurs sélectionnées en strings pour la comparaison
                                        // IMPORTANT: Gérer aussi les cas où values contient des nombres
                                        const selectedMyKeys = values.map(v => {
                                            // Si c'est déjà une string, la retourner
                                            if (typeof v === 'string') return v;
                                            // Sinon convertir en string
                                            return String(v);
                                        });
                                        
                                        // Vérifier l'opérateur pour utiliser la bonne logique
                                        // IMPORTANT: Même dans le cas OR/default, vérifier l'opérateur pour gérer correctement AND
                                        // Normaliser l'opérateur pour la comparaison
                                        const normalizedOperator = operator ? operator.trim().toUpperCase() : 'OR';
                                        if (normalizedOperator === 'AND') {
                                            // Pour AND, toutes les valeurs sélectionnées doivent être présentes dans criterion_mykeys
                                            matches = selectedMyKeys.every(selectedKey => criterion_mykeys.includes(selectedKey));
                                        } else {
                                            // Pour OR, au moins une valeur sélectionnée doit être présente dans criterion_mykeys
                                            matches = selectedMyKeys.some(selectedKey => {
                                                const found = criterion_mykeys.includes(selectedKey);
                                              
                                                return found;
                                            });
                                        }
                                        
                                       
                                      
                                    } catch (e) {
                                        console.error(`Erreur lors du filtrage par ${filterName} pour le camping ${index + 1}:`, e);
                                        const normalizedOperator = operator ? operator.trim().toUpperCase() : 'OR';
                                        matches = normalizedOperator === 'AND' ? false : true; // En cas d'erreur, ne pas afficher si AND, afficher si OR
                                    }
                                } else {
                                    // Pour les autres filtres, utiliser la comparaison standard
                                   
                                    
                                    matches = values.some(value => dataValuesOR.map(String).includes(String(value)));
                                }
                                
                                break;
                        }
        
                        if (!matches) {
                            shouldShow = false;
                            // Debug: Log quand un filtre échoue
                            console.log('DEBUG FILTRE ECHOUE:', {
                                filterName: filterName,
                                campingName: campingName,
                                matches: matches,
                                shouldShow: shouldShow,
                                dataAttributeValue: dataAttributeValue
                            });
                            // Sortir de la boucle dès qu'un filtre échoue
                            break;
                        }
                    } // Fin du if (dataAttribute)
            } // Fin de la boucle for...of
                } // Fin du if (shouldShow) pour les filtres
        
            // Afficher tous les éléments correspondants
            // IMPORTANT: Appliquer les styles sur campingElement (le <li>) qui contient les attributs data-gt-*
            // mais aussi sur camping (l'élément sélectionné) pour s'assurer que tous les éléments sont mis à jour
            if (shouldShow) {
                    // Debug: Log pour voir quels campings sont affichés
                    const dept = campingElement.getAttribute('data-gt-department');
                    const etoiles = campingElement.getAttribute('data-gt-etoiles');
                    console.log('DEBUG CAMPING AFFICHE:', {
                        campingName: campingName,
                        department: dept,
                        etoiles: etoiles,
                        shouldShow: shouldShow,
                        filters: Object.keys(filters)
                    });
                    // Afficher le camping - retirer TOUTES les classes qui masquent l'élément
                    // Appliquer sur campingElement (le <li>) ET sur camping (l'élément sélectionné)
                    [campingElement, camping].forEach(el => {
                        if (el) {
                            el.classList.remove('gt-ws-ctv-hidden');
                            el.classList.add('gt-ws-ctv-visible');
                            el.style.display = '';
                            el.style.visibility = '';
                            // Ne pas utiliser removeAttribute('style') car cela peut supprimer d'autres styles
                            // Utiliser directement style.display = '' pour forcer l'affichage
                        }
                    });
                    // Essayer plusieurs attributs pour identifier le camping (utiliser campingElement qui a les attributs)
                    // IMPORTANT: data-gt-camping contient le campingKey/idSite qui correspond à state.campings[].idSite
                    let campingId = campingElement.getAttribute('data-gt-camping') || 
                                  campingElement.getAttribute('data-gt-camping-id') ||
                                  campingElement.getAttribute('data-post-id') ||
                                  campingElement.className.match(/post-(\d+)/)?.[1] ||
                                  camping.className.match(/post-(\d+)/)?.[1];
                    if (campingId) {
                        // Convertir en string pour être cohérent avec la carte
                        // S'assurer qu'on n'ajoute pas de doublons
                        const campingIdStr = campingId.toString();
                        if (!visibleCampingsIds.includes(campingIdStr)) {
                            visibleCampingsIds.push(campingIdStr);
                        }
                    }
                    visibleCampings.push(camping); // Track visible campings
                } else {
                    // Masquer le camping - seulement si il ne correspond pas aux filtres
                    // Appliquer sur campingElement (le <li>) ET sur camping (l'élément sélectionné)
                    [campingElement, camping].forEach(el => {
                        if (el) {
                            el.classList.remove('gt-ws-ctv-visible');
                            el.classList.add('gt-ws-ctv-hidden');
                            el.style.display = 'none';
                        }
                    });
                }
                
                
            });

            // Debug: Log final du nombre de campings visibles
            console.log('DEBUG RUNFILTERS - Résultat final:', {
                totalCampings: allCampings.length,
                visibleCampings: visibleCampings.length,
                visibleCampingsIds: visibleCampingsIds.length,
                filters: Object.keys(filters)
            });
            
            // Debug: Vérifier la correspondance entre les IDs extraits et ceux dans state.campings
            if (state.campings && state.campings.length > 0) {
                const campingsIdsInState = state.campings.map(c => c.idSite?.toString()).filter(Boolean);
                const matchingIds = visibleCampingsIds.filter(id => campingsIdsInState.includes(id));
                if (matchingIds.length < visibleCampingsIds.length) {
                    const missingIds = visibleCampingsIds.filter(id => !campingsIdsInState.includes(id));
                    console.warn('IDs non trouvés dans state.campings:', missingIds.slice(0, 10));
                }
            }
            
            if (regionFromForm && state.visibleCampingsIds && state.visibleCampingsIds.length > 0) {
                // Combiner les filtres : garder seulement les campings qui sont à la fois dans la région ET dans les filtres de la sidebar
                const regionFilteredIds = state.visibleCampingsIds.map(id => id.toString());
                const sidebarFilteredIds = visibleCampingsIds.map(id => id.toString());
                // Intersection des deux listes
                state.visibleCampingsIds = regionFilteredIds.filter(id => sidebarFilteredIds.includes(id));
            } else {
                // Pas de région sélectionnée, utiliser directement les IDs filtrés par la sidebar
                state.visibleCampingsIds = visibleCampingsIds.map(id => id.toString());
            }
            
            // Obtenir le nombre total de campings filtrés (pas seulement ceux visibles sur la page)
            const totalFilteredCampings = state.visibleCampingsIds && state.visibleCampingsIds.length > 0 
                ? state.visibleCampingsIds.length 
                : visibleCampingsIds.length;
        
            // Mettre à jour le message d'absence de résultats
            updateNoResultsMessage(visibleCampings.length);
            
            // Stocker les IDs filtrés dans un attribut data pour que le script jQuery puisse y accéder
            const campingsContainer = document.querySelector('.gt-ws-ctv-campings-block, .wp-block-query[data-namespace="gt-ws-ctv-campings"]');
            if (campingsContainer) {
                if (state.visibleCampingsIds && state.visibleCampingsIds.length > 0) {
                    // Il y a des filtres actifs, stocker les IDs filtrés
                    campingsContainer.setAttribute('data-filtered-camping-ids', JSON.stringify(state.visibleCampingsIds));
                    campingsContainer.setAttribute('data-has-filters', 'true');
                } else {
                    // Pas de filtres actifs, supprimer l'attribut pour indiquer qu'on affiche tous les campings
                    campingsContainer.removeAttribute('data-filtered-camping-ids');
                    campingsContainer.setAttribute('data-has-filters', 'false');
                }
            }
            
            // Fonction pour vérifier si un élément correspond à TOUS les filtres actifs
            const checkAllFilters = (element, activeFiltersObj) => {
                const $item = jQuery(element);
                let matchesAllFilters = true;
                
                // Vérifier le filtre département
                if (activeFiltersObj.department && activeFiltersObj.department.length > 0) {
                    const department = $item.attr('data-gt-department');
                    if (!department) {
                        matchesAllFilters = false;
                    } else {
                        const departmentNormalized = department.trim().toLowerCase();
                        const matchesDept = activeFiltersObj.department.some(filterValue => {
                            const filterValueNormalized = String(filterValue).trim().toLowerCase();
                            return departmentNormalized === filterValueNormalized;
                        });
                        if (!matchesDept) {
                            matchesAllFilters = false;
                        }
                    }
                }
                
                // Vérifier le filtre étoiles
                if (matchesAllFilters && activeFiltersObj.etoiles && activeFiltersObj.etoiles.length > 0) {
                    const etoilesAttr = $item.attr('data-gt-etoiles');
                    if (!etoilesAttr || etoilesAttr === '' || etoilesAttr === '[]') {
                        matchesAllFilters = false;
                    } else {
                        const numericValues = activeFiltersObj.etoiles.map(v => {
                            const num = parseInt(String(v).trim(), 10);
                            return isNaN(num) ? null : num;
                        }).filter(v => v !== null);
                        
                        const campingEtoiles = parseInt(String(etoilesAttr).trim(), 10);
                        if (isNaN(campingEtoiles) || !numericValues.includes(campingEtoiles)) {
                            matchesAllFilters = false;
                        }
                    }
                }
                
                // Vérifier les filtres piscine/service/activites (via data-gt-criterion)
                if (matchesAllFilters && (activeFiltersObj.piscine || activeFiltersObj.service || activeFiltersObj.activites)) {
                    const criterionAttr = $item.attr('data-gt-criterion');
                    if (!criterionAttr || criterionAttr === '[]') {
                        // Si un filtre de critère est actif mais l'attribut est vide, ne pas afficher
                        if (activeFiltersObj.piscine || activeFiltersObj.service || activeFiltersObj.activites) {
                            matchesAllFilters = false;
                        }
                    } else {
                        try {
                            let criterion_mykeys = JSON.parse(criterionAttr);
                            if (!Array.isArray(criterion_mykeys)) {
                                criterion_mykeys = [];
                            }
                            criterion_mykeys = criterion_mykeys.map(k => String(k));
                            
                            // Vérifier piscine (avec opérateur AND)
                            if (activeFiltersObj.piscine && activeFiltersObj.piscine.length > 0) {
                                const selectedMyKeys = activeFiltersObj.piscine.map(v => String(v));
                                // Pour piscine, utiliser AND (toutes les valeurs doivent être présentes)
                                const matchesPiscine = selectedMyKeys.every(selectedKey => criterion_mykeys.includes(selectedKey));
                                if (!matchesPiscine) {
                                    matchesAllFilters = false;
                                }
                            }
                            
                            // Vérifier service (avec opérateur AND)
                            if (matchesAllFilters && activeFiltersObj.service && activeFiltersObj.service.length > 0) {
                                const selectedMyKeys = activeFiltersObj.service.map(v => String(v));
                                // Pour service, utiliser AND (toutes les valeurs doivent être présentes)
                                const matchesService = selectedMyKeys.every(selectedKey => criterion_mykeys.includes(selectedKey));
                                if (!matchesService) {
                                    matchesAllFilters = false;
                                }
                            }
                            
                            // Vérifier activites (avec opérateur AND)
                            if (matchesAllFilters && activeFiltersObj.activites && activeFiltersObj.activites.length > 0) {
                                const selectedMyKeys = activeFiltersObj.activites.map(v => String(v));
                                // Pour activites, utiliser AND (toutes les valeurs doivent être présentes)
                                const matchesActivites = selectedMyKeys.every(selectedKey => criterion_mykeys.includes(selectedKey));
                                if (!matchesActivites) {
                                    matchesAllFilters = false;
                                }
                            }
                        } catch (e) {
                            console.warn('Erreur parsing data-gt-criterion dans checkAllFilters:', e);
                            matchesAllFilters = false;
                        }
                    }
                }
                
                return matchesAllFilters;
            };
            
            // CODE IMMÉDIAT: Forcer l'affichage de tous les éléments qui correspondent à TOUS les filtres actifs
            // Ce code s'exécute immédiatement après le filtrage pour corriger les éléments mal masqués
            const activeFiltersImmediate = {};
            document.querySelectorAll('.gt-campings-filtre').forEach(filterContainer => {
                const filterName = filterContainer.getAttribute('data-gt-filtre-name');
                if (!filterName) return;
                
                const multiselect = filterContainer.querySelector('.gt-campings-filtre__multiselect');
                const select = filterContainer.querySelector('select.gt-campings-filtre__select');
                
                let selectedValues = [];
                if (multiselect) {
                    selectedValues = Array.from(multiselect.querySelectorAll('input[type="checkbox"]:checked'))
                        .map(input => input.value)
                        .filter(v => v !== '');
                } else if (select) {
                    selectedValues = Array.from(select.selectedOptions)
                        .map(option => option.value)
                        .filter(v => v !== '');
                }
                
                if (selectedValues.length > 0) {
                    activeFiltersImmediate[filterName] = selectedValues;
                }
            });
            
            // Parcourir tous les éléments et vérifier s'ils correspondent à TOUS les filtres
            if (Object.keys(activeFiltersImmediate).length > 0) {
                const $allItemsImmediate = jQuery('li.wp-block-post[data-gt-camping], li.wp-block-post[data-gt-department]');
                $allItemsImmediate.each(function() {
                    const $item = jQuery(this);
                    const matchesAll = checkAllFilters(this, activeFiltersImmediate);
                    
                    if (matchesAll) {
                        // L'élément correspond à TOUS les filtres, l'afficher
                        $item.removeClass('gt-ws-ctv-hidden')
                             .addClass('gt-ws-ctv-visible');
                        $item.removeAttr('style');
                        $item.css({
                            'display': 'block',
                            'visibility': 'visible'
                        });
                        $item.show();
                    } else {
                        // L'élément ne correspond pas à tous les filtres, le masquer
                        $item.removeClass('gt-ws-ctv-visible')
                             .addClass('gt-ws-ctv-hidden');
                        $item.css('display', 'none');
                    }
                });
            }
            
            // Les filtres service et piscine sont maintenant gérés par la fonction checkAllFilters ci-dessus
            
            // PAGINATION SUPPRIMÉE : Plus de masquage de pagination
            
            // Afficher tous les campings filtrés (sans limitation)
            // Attendre un peu pour que le DOM soit mis à jour
            setTimeout(() => {
                const $list = jQuery('.gt-ws-ctv-campings-list, .wp-block-post-template').first();
                if ($list.length > 0) {
                    // Afficher TOUS les éléments filtrés (SANS AUCUNE LIMITATION)
                    const $allItems = $list.find('li.wp-block-post');
                    
                    // Récupérer les filtres actifs pour vérification
                    const activeFiltersForDisplay = {};
                    document.querySelectorAll('.gt-campings-filtre').forEach(filterContainer => {
                        const filterName = filterContainer.getAttribute('data-gt-filtre-name');
                        if (!filterName) return;
                        
                        const multiselect = filterContainer.querySelector('.gt-campings-filtre__multiselect');
                        const select = filterContainer.querySelector('select.gt-campings-filtre__select');
                        
                        let selectedValues = [];
                        if (multiselect) {
                            selectedValues = Array.from(multiselect.querySelectorAll('input[type="checkbox"]:checked'))
                                .map(input => input.value)
                                .filter(v => v !== '');
                        } else if (select) {
                            selectedValues = Array.from(select.selectedOptions)
                                .map(option => option.value)
                                .filter(v => v !== '');
                        }
                        
                        if (selectedValues.length > 0) {
                            activeFiltersForDisplay[filterName] = selectedValues;
                        }
                    });
                    
                    // Parcourir TOUS les éléments et déterminer s'ils doivent être affichés
                    $allItems.each(function() {
                        const $item = jQuery(this);
                        let shouldShow = false;
                        
                        // Si l'élément n'a pas gt-ws-ctv-hidden, il doit être visible
                        if (!$item.hasClass('gt-ws-ctv-hidden') || $item.hasClass('gt-ws-ctv-visible')) {
                            shouldShow = true;
                        }
                        
                        // Vérification supplémentaire : utiliser checkAllFilters pour vérifier TOUS les filtres
                        if (!shouldShow && Object.keys(activeFiltersForDisplay).length > 0) {
                            shouldShow = checkAllFilters(this, activeFiltersForDisplay);
                        }
                        
                        // Afficher ou masquer l'élément
                        if (shouldShow) {
                            $item.removeClass('gt-ws-ctv-hidden')
                                 .addClass('gt-ws-ctv-visible');
                            $item.removeAttr('style');
                            $item.css({
                                'display': 'block',
                                'visibility': 'visible'
                            });
                            $item.show();
                        } else {
                            $item.removeClass('gt-ws-ctv-visible')
                                 .addClass('gt-ws-ctv-hidden')
                                 .hide();
                        }
                    });
                }
            }, 100);
            
            // S'assurer que tous les campings filtrés sont affichés
            setTimeout(() => {
                const totalFilteredVisible = state.visibleCampingsIds && state.visibleCampingsIds.length > 0 
                    ? state.visibleCampingsIds.length 
                    : visibleCampingsIds.length;
                
                
                // Récupérer les filtres actifs pour vérification supplémentaire
                const activeFiltersCheck = {};
                document.querySelectorAll('.gt-campings-filtre').forEach(filterContainer => {
                    const filterName = filterContainer.getAttribute('data-gt-filtre-name');
                    if (!filterName) return;
                    
                    const multiselect = filterContainer.querySelector('.gt-campings-filtre__multiselect');
                    const select = filterContainer.querySelector('select.gt-campings-filtre__select');
                    
                    let selectedValues = [];
                    if (multiselect) {
                        selectedValues = Array.from(multiselect.querySelectorAll('input[type="checkbox"]:checked'))
                            .map(input => input.value)
                            .filter(v => v !== '');
                    } else if (select) {
                        selectedValues = Array.from(select.selectedOptions)
                            .map(option => option.value)
                            .filter(v => v !== '');
                    }
                    
                    if (selectedValues.length > 0) {
                        activeFiltersCheck[filterName] = selectedValues;
                    }
                });
                
                // Afficher tous les campings filtrés (sans limitation)
                const $allItems = jQuery('.gt-ws-ctv-campings-list li.wp-block-post, .wp-block-post-template li.wp-block-post');
                $allItems.each(function() {
                    const $item = jQuery(this);
                    const campingId = $item.attr('data-gt-camping') || 
                                    $item.attr('data-gt-camping-id') ||
                                    $item.attr('data-post-id') ||
                                    $item[0].className.match(/post-(\d+)/)?.[1];
                    
                    let shouldShow = false;
                    
                    // Vérifier si le camping est dans la liste des visibles
                    if (campingId && (
                        (state.visibleCampingsIds && state.visibleCampingsIds.includes(campingId.toString())) ||
                        (visibleCampingsIds && visibleCampingsIds.includes(campingId.toString()))
                    )) {
                        shouldShow = true;
                    }
                    
                    // Vérification supplémentaire : utiliser checkAllFilters pour vérifier TOUS les filtres
                    if (!shouldShow && Object.keys(activeFiltersCheck).length > 0) {
                        shouldShow = checkAllFilters(this, activeFiltersCheck);
                    }
                    
                    // Si le camping doit être affiché, forcer l'affichage
                    if (shouldShow) {
                        // Forcer l'affichage complet
                        $item.removeClass('gt-ws-ctv-hidden')
                             .addClass('gt-ws-ctv-visible');
                        // Retirer tous les styles inline qui pourraient masquer
                        $item.removeAttr('style');
                        $item.css({
                            'display': 'block',
                            'visibility': 'visible'
                        });
                        $item.show();
                    }
                });
                
                // Forcer l'affichage de TOUS les éléments visibles
                const $visibleItems = jQuery('.gt-ws-ctv-campings-list li.wp-block-post.gt-ws-ctv-visible, .wp-block-post-template li.wp-block-post.gt-ws-ctv-visible');
                $visibleItems.each(function() {
                    const $item = jQuery(this);
                    $item.removeAttr('style');
                    $item.css({ 'display': '', 'visibility': '' });
                    $item.show();
                });
                
                // Afficher tous les éléments visibles
                const $itemsWithoutHidden = jQuery('.gt-ws-ctv-campings-list li.wp-block-post:not(.gt-ws-ctv-hidden), .wp-block-post-template li.wp-block-post:not(.gt-ws-ctv-hidden)');
                $itemsWithoutHidden.each(function() {
                    const $item = jQuery(this);
                    if (!$item.hasClass('gt-ws-ctv-hidden')) {
                        $item.removeAttr('style');
                        $item.css({ 'display': '', 'visibility': '' });
                        $item.show();
                    }
                });
                
                // CODE DE SECOURS: Vérifier les filtres actifs et forcer l'affichage des éléments correspondants
                // Cela corrige les cas où la comparaison échoue pour une raison quelconque
                const activeFilters = {};
                document.querySelectorAll('.gt-campings-filtre').forEach(filterContainer => {
                    const filterName = filterContainer.getAttribute('data-gt-filtre-name');
                    if (!filterName) return;
                    
                    const multiselect = filterContainer.querySelector('.gt-campings-filtre__multiselect');
                    const select = filterContainer.querySelector('select.gt-campings-filtre__select');
                    
                    let selectedValues = [];
                    if (multiselect) {
                        selectedValues = Array.from(multiselect.querySelectorAll('input[type="checkbox"]:checked'))
                            .map(input => input.value)
                            .filter(v => v !== '');
                    } else if (select) {
                        selectedValues = Array.from(select.selectedOptions)
                            .map(option => option.value)
                            .filter(v => v !== '');
                    }
                    
                    if (selectedValues.length > 0) {
                        activeFilters[filterName] = selectedValues;
                    }
                });
                
                // CODE DE SECOURS: Utiliser checkAllFilters pour vérifier TOUS les filtres
                if (Object.keys(activeFilters).length > 0) {
                    const $allItems = jQuery('.gt-ws-ctv-campings-list li.wp-block-post, .wp-block-post-template li.wp-block-post');
                    $allItems.each(function() {
                        const $item = jQuery(this);
                        const matchesAll = checkAllFilters(this, activeFilters);
                        
                        if (matchesAll) {
                            // L'élément correspond à TOUS les filtres, l'afficher
                            $item.removeClass('gt-ws-ctv-hidden')
                                 .addClass('gt-ws-ctv-visible');
                            $item.removeAttr('style');
                            $item.css({
                                'display': 'block',
                                'visibility': 'visible'
                            });
                            $item.show();
                        } else {
                            // L'élément ne correspond pas à tous les filtres, le masquer
                            $item.removeClass('gt-ws-ctv-visible')
                                 .addClass('gt-ws-ctv-hidden');
                            $item.css('display', 'none');
                        }
                    });
                }
                
                // CODE FINAL: Forcer l'affichage de tous les éléments qui n'ont pas gt-ws-ctv-hidden
                // Cela garantit que tous les éléments visibles sont vraiment affichés
                const $allVisibleItems = jQuery('.gt-ws-ctv-campings-list li.wp-block-post:not(.gt-ws-ctv-hidden), .wp-block-post-template li.wp-block-post:not(.gt-ws-ctv-hidden)');
                $allVisibleItems.each(function() {
                    const $item = jQuery(this);
                    // Forcer l'affichage
                    // TOUJOURS forcer l'affichage, même si display:none est défini
                    $item.removeAttr('style');
                    $item.css({ 
                        'display': 'block !important', 
                        'visibility': 'visible !important' 
                    });
                    $item.show();
                });
                
                // CODE ULTIME: Parcourir TOUS les éléments et forcer l'affichage de ceux qui correspondent aux filtres
                // Cela corrige tous les cas où un élément devrait être visible mais ne l'est pas
                const $allCampings = jQuery('li.wp-block-post[data-gt-department], li.wp-block-post[data-gt-camping], li.wp-block-post[data-gt-criterion]');
                $allCampings.each(function() {
                    const $item = jQuery(this);
                    const department = $item.attr('data-gt-department');
                    const criterionAttr = $item.attr('data-gt-criterion');
                    
                    // Utiliser checkAllFilters pour vérifier TOUS les filtres
                    const matchesAll = checkAllFilters(this, activeFilters);
                    
                    if (matchesAll) {
                        // L'élément correspond à TOUS les filtres, le forcer à s'afficher
                        $item.removeClass('gt-ws-ctv-hidden')
                             .addClass('gt-ws-ctv-visible');
                        $item.removeAttr('style');
                        $item.css({ 
                            'display': 'block', 
                            'visibility': 'visible' 
                        });
                        $item.show();
                    } else {
                        // L'élément ne correspond pas à tous les filtres, le masquer
                        $item.removeClass('gt-ws-ctv-visible')
                             .addClass('gt-ws-ctv-hidden');
                        $item.css('display', 'none');
                    }
                    
                    // Si l'élément n'a pas la classe gt-ws-ctv-hidden, il doit être visible
                    if (!$item.hasClass('gt-ws-ctv-hidden')) {
                        $item.addClass('gt-ws-ctv-visible');
                        $item.removeAttr('style');
                        $item.css({ 
                            'display': 'block !important', 
                            'visibility': 'visible !important' 
                        });
                        $item.show();
                    }
                });
            }, 300);
            
            // S'assurer que showSearchResults est false quand on filtre avec la sidebar
            if (store('gt/ctv')?.state) {
                store('gt/ctv').state.showSearchResults = false;
            }
            
            // Toujours mettre à jour la carte avec les nouveaux marqueurs visibles
            if (store('gt/ctv')?.actions?.updateMap) {
                store('gt/ctv').actions.updateMap();
            }
        },
        
        clearFilter: (e) => {
            const ctv = store("gt/ctv");
            let filterContainer = e.target.closest('.gt-campings-filtre');
            
            // Check if it's a select or checkbox
            let select = filterContainer.querySelector('select.gt-campings-filtre__select');
            if (select) {
                // For select multiple, deselect all and select "Tous"
                Array.from(select.options).forEach(option => {
                    option.selected = option.value === '';
                });
            } else {
                // For checkboxes, uncheck all and check "Tous"
                let checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach(checkbox => {
                    checkbox.checked = false;
                });
                e.target.checked = true;
            }

            let cookieName = filterContainer.getAttribute('data-gt-cookie');
            if (cookieName) {
                Cookies.set(cookieName, []);
                ctv.state[cookieName] = [];
            }

            store('gt/ctv').actions.runFilters(e);

            // ctv.actions.submitForm();
        },
        clearAllFilters: (e) => {
            const ctv = store("gt/ctv");
            
            // Vérifier s'il y a une région sélectionnée dans le formulaire
            let regionFromForm = '';
            const formContainer = document.querySelector('.gt-ws-ctv-form-resa');
            if (formContainer) {
                const regionSelect = formContainer.querySelector('select[name="accommodation_region"]');
                if (regionSelect && regionSelect.value) {
                    regionFromForm = regionSelect.value;
                }
            }
            
            // Reset all filters (both checkboxes, selects, and multiselects)
            document.querySelectorAll('.gt-campings-filtre').forEach(filterContainer => {
                let multiselect = filterContainer.querySelector('.gt-campings-filtre__multiselect');
                let select = filterContainer.querySelector('select.gt-campings-filtre__select');
                
                if (multiselect) {
                    // For multiselect dropdown, uncheck all
                    multiselect.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                        checkbox.checked = false;
                    });
                    // Update label
                    store('gt/ctv').actions.updateMultiselectLabel(multiselect);
                } else if (select) {
                    // For select multiple, deselect all and select "Tous"
                    Array.from(select.options).forEach(option => {
                        option.selected = option.value === '';
                    });
                } else {
                    // For checkboxes, reset to "Tous"
                    let checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach(checkbox => {
                        checkbox.checked = checkbox.value != "" ? false : true;
                    });
                }
                
                let cookieName = filterContainer.getAttribute('data-gt-cookie');
                if (cookieName) {
                    Cookies.set(cookieName, []);
                    ctv.state[cookieName] = [];
                }
            });

            // Réinitialiser visibleCampingsIds seulement si aucune région n'est sélectionnée
            // Sinon, laisser runFilters() gérer la combinaison avec le filtre de région
            if (!regionFromForm) {
                state.visibleCampingsIds = [];
            }
            // Si une région est sélectionnée, state.visibleCampingsIds reste inchangé
            // et runFilters() combinera correctement les filtres

            store('gt/ctv').actions.runFilters();

        },
        toggleSidebar: (e) => {
            const context = getContext();
            context.isSidebarOpen = !context.isSidebarOpen;

            document.body.classList.toggle('gt-ws-sidebar-toggled');

           

        },
        toggleFilter: (e) => {
            const context = getContext();
            if(!context.isAccordeon) return;

            let filter = e.target.closest('.gt-campings-filtre');
            filter.classList.toggle('closed');

            if(filter.classList.contains('closed')){
                filter.setAttribute('aria-expanded', 'false');
            }
            else{
                filter.setAttribute('aria-expanded', 'true');
            }

        },
        handleKeydown: (e) => {
            if (e.key === 'Escape') {
                store('gt/ctv').actions.toggleSidebar(e);
            }

            const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const sidebar = document.querySelector('.gt-campings-filtres__sidebar');
            const firstFocusableElement = sidebar.querySelectorAll(focusableElements)[0];
            const focusableContent = sidebar.querySelectorAll(focusableElements);
            const lastFocusableElement = focusableContent[focusableContent.length - 1];

            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        },
        stickButton: (e) => {
            const element = getElement();
            const scrollTop = window.scrollY;
            const actionsBottom = element.ref.getBoundingClientRect().bottom + window.scrollY;
            const height = element.ref.offsetHeight;
            element.ref.querySelector('.gt-campings-actions-placeholder').style.height = `${height}px`;

            if (scrollTop > actionsBottom) {
                state.filterButtonSticked = true;
            } else {
                state.filterButtonSticked = false;
            }
        },

               // Initialiser l'écoute des changements du formulaire
               initFormListener: () => {
                   // Attendre que le formulaire soit chargé
                   const checkForm = () => {
                       const formContainer = document.querySelector('.gt-ws-ctv-form-resa');
                       if (formContainer) {
                           store('gt/ctv').actions.listenToFormChanges();
                           
                           // Appliquer le filtrage initial basé sur l'URL
                           store('gt/ctv').actions.applyInitialFilter();
                           
                           // Initialiser les événements de hover sur les campings
                           store('gt/ctv').actions.initCampingHoverEvents();
                           
                           // Initialiser les labels des multiselects
                           document.querySelectorAll('.gt-campings-filtre__multiselect').forEach(multiselect => {
                               store('gt/ctv').actions.updateMultiselectLabel(multiselect);
                           });
                       } else {
                           // Réessayer après 100ms si le formulaire n'est pas encore chargé
                           setTimeout(checkForm, 100);
                       }
                   };
                   checkForm();
               },

               // Appliquer le filtrage initial basé sur les paramètres URL
               applyInitialFilter: () => {
                   const urlParams = new URLSearchParams(window.location.search);
                   const region = urlParams.get('region');
                   
                   if (region) {
                       
                       // Appliquer le filtrage CSS immédiatement
                       store('gt/ctv').actions.filterCampingsByRegionCSS(region);
                       
                       // Déclencher le filtrage AJAX avec la région de l'URL
                       const formData = {
                           region: region,
                           camping: '',
                           type: '',
                           nbPers: urlParams.get('nbPers') || '',
                           arrival: urlParams.get('arrival') || '',
                           departure: urlParams.get('departure') || ''
                       };
                       
                       store('gt/ctv').actions.filterCampingsByAjax(formData);
                   }
               },

               // Filtrer les campings par région avec CSS (pour le filtrage initial)
               filterCampingsByRegionCSS: (region) => {
                   
                   // Trouver le conteneur des campings
                   let campingsContainer = document.querySelector('.wp-block-query[data-namespace="gt-ws-ctv-campings"] .wp-block-post-template');
                   
                   if (!campingsContainer) {
                       campingsContainer = document.querySelector('.gt-ws-ctv-campings-block .wp-block-post-template');
                   }
                   
                   if (!campingsContainer) {
                       campingsContainer = document.querySelector('.wp-block-query .wp-block-post-template');
                   }
                   
                   if (!campingsContainer) {
                       campingsContainer = document.querySelector('.wp-block-post-template');
                   }
                   
                   if (!campingsContainer) {
                       return;
                   }
                   
                   
                   // Trouver tous les campings
                   const allCampings = campingsContainer.querySelectorAll('li');
                   
                   let visibleCount = 0;
                   
                   allCampings.forEach(camping => {
                       // Chercher le texte de la région dans le camping
                       const regionText = camping.textContent.toLowerCase();
                       const regionLower = region.toLowerCase();
                       
                       // Vérifier si le camping correspond à la région
                       let shouldShow = false;
                       
                       // Correspondances flexibles pour les régions
                       if (regionLower.includes('bretagne') && regionText.includes('bretagne')) {
                           shouldShow = true;
                       } else if (regionLower.includes('ile-de-france') && regionText.includes('ile-de-france')) {
                           shouldShow = true;
                       } else if (regionLower.includes('auvergne') && regionText.includes('auvergne')) {
                           shouldShow = true;
                       } else if (regionLower.includes('nouvelle-aquitaine') && regionText.includes('nouvelle-aquitaine')) {
                           shouldShow = true;
                       } else if (regionLower.includes('occitanie') && regionText.includes('occitanie')) {
                           shouldShow = true;
                       } else if (regionLower.includes('provence') && regionText.includes('provence')) {
                           shouldShow = true;
                       } else if (regionLower.includes('paca') && regionText.includes('paca')) {
                           shouldShow = true;
                       } else if (regionLower.includes('normandie') && regionText.includes('normandie')) {
                           shouldShow = true;
                       } else if (regionLower.includes('hauts-de-france') && regionText.includes('hauts-de-france')) {
                           shouldShow = true;
                       } else if (regionLower.includes('grand-est') && regionText.includes('grand-est')) {
                           shouldShow = true;
                       } else if (regionLower.includes('bourgogne') && regionText.includes('bourgogne')) {
                           shouldShow = true;
                       } else if (regionLower.includes('centre') && regionText.includes('centre')) {
                           shouldShow = true;
                       } else if (regionLower.includes('pays-de-la-loire') && regionText.includes('pays-de-la-loire')) {
                           shouldShow = true;
                       }
                       
                       if (shouldShow) {
                           camping.style.display = '';
                           camping.style.opacity = '1';
                           visibleCount++;
                       } else {
                           camping.style.display = 'none';
                       }
                   });
                   
                   // Mettre à jour le compteur
                   const counter = document.querySelector('.gt-campings-count, .wp-block-query__results-count');
                   if (counter) {
                       counter.textContent = `${visibleCount} camping${visibleCount > 1 ? 's' : ''} trouvé${visibleCount > 1 ? 's' : ''}`;
                   }
                   
                   // Mettre à jour le message d'absence de résultats
                   updateNoResultsMessage(visibleCount);
                   
               },

        // Écouter les changements d'URL pour déclencher le filtrage
        listenToUrlChanges: () => {
            // Écouter les changements d'URL (bouton retour/avant du navigateur)
            window.addEventListener('popstate', () => {
                store('gt/ctv').actions.filterCampingsByUrl();
            });

            // Écouter les changements d'URL programmatiques
            let currentUrl = window.location.href;
            setInterval(() => {
                if (window.location.href !== currentUrl) {
                    currentUrl = window.location.href;
                    store('gt/ctv').actions.filterCampingsByUrl();
                }
            }, 100);
        },

        // Filtrer les campings basé sur l'URL
        filterCampingsByUrl: () => {
            const urlParams = new URLSearchParams(window.location.search);
            const region = urlParams.get('region');
            const camping = urlParams.get('idCamping');
            const type = urlParams.get('type');
            const nbPers = urlParams.get('nbPers');


            // Filtrer les campings basé sur les paramètres URL
            const campings = document.querySelectorAll('.wp-block-query[data-namespace="gt-ws-ctv-campings"] .wp-block-post, .wp-block-query[data-namespace="gt-ws-ctv-campings"] .camping, .wp-block-query .wp-block-post, .gt-ws-ctv-campings-block .wp-block-post, .gt-ws-ctv-campings-block .camping, .gt-ws-ctv-campings-block .wp-block-post-template li');

            let visibleCount = 0;
            campings.forEach(camping => {
                let shouldShow = true;

                // Filtrer par région
                if (region) {
                    const campingText = camping.textContent.toLowerCase();
                    const regionText = region.toLowerCase();
                    if (!campingText.includes(regionText)) {
                        shouldShow = false;
                    }
                }

                // Filtrer par camping spécifique
                if (camping) {
                    const campingId = camping.getAttribute('data-post-id') || camping.getAttribute('data-camping-id');
                    if (campingId && campingId !== camping) {
                        shouldShow = false;
                    }
                }

                // Filtrer par type d'hébergement
                if (type) {
                    const campingText = camping.textContent.toLowerCase();
                    const typeText = type.toLowerCase();
                    if (!campingText.includes(typeText)) {
                        shouldShow = false;
                    }
                }

                // Filtrer par capacité (nombre de personnes)
                if (nbPers) {
                    const campingText = camping.textContent;
                    const capacityMatch = campingText.match(/(?:jusqu'à|max|maximum|capacité|personnes?)\s*(\d+)/i);
                    if (capacityMatch) {
                        const maxCapacity = parseInt(capacityMatch[1]);
                        if (maxCapacity < parseInt(nbPers)) {
                            shouldShow = false;
                        }
                    }
                }

                // Afficher/masquer le camping
                camping.style.display = shouldShow ? '' : 'none';
                if (shouldShow) visibleCount++;
            });
            
            // Mettre à jour le message d'absence de résultats
            updateNoResultsMessage(visibleCount);

        },

        // Initialiser les événements de hover sur les éléments de camping
        initCampingHoverEvents: () => {
            
            // Attendre que les éléments de camping soient chargés
            const checkCampings = () => {
                const campingElements = document.querySelectorAll('[data-gt-camping]');
                
                if (campingElements.length > 0) {
                    
                    campingElements.forEach((element, index) => {
                        const campingId = element.getAttribute('data-gt-camping');
                        
                        if (campingId) {
                            // Vérifier si les événements sont déjà attachés
                            if (element.hasAttribute('data-hover-events-attached')) {
                                return;
                            }
                            
                            // Ajouter les événements de hover
                            element.addEventListener('mouseenter', () => {
                                try {
                                    store('gt/ctv').actions.hoverCamping(campingId);
                                } catch (error) {
                                    console.error('❌ Erreur lors du hover:', error);
                                }
                            });
                            
                            element.addEventListener('mouseleave', () => {
                                try {
                                    store('gt/ctv').actions.unhoverCamping(campingId);
                                } catch (error) {
                                    console.error('❌ Erreur lors du unhover:', error);
                                }
                            });
                            
                            // Marquer comme ayant des événements attachés
                            element.setAttribute('data-hover-events-attached', 'true');
                        } else {
                        }
                    });
                    
                    
                    // Diagnostic de l'état de la carte
                    try {
                        store('gt/ctv').actions.debugMapState();
                    } catch (error) {
                        console.error('❌ Erreur lors du diagnostic:', error);
                    }
                } else {
                    // Réessayer après 200ms si les éléments ne sont pas encore chargés
                    setTimeout(checkCampings, 200);
                }
            };
            checkCampings();
        },

        // Filtrer les campings via AJAX
        filterCampingsByAjax: (formData) => {
            
            // Trouver le conteneur des campings - essayer plusieurs sélecteurs
            let campingsContainer = document.querySelector('.wp-block-query[data-namespace="gt-ws-ctv-campings"] .wp-block-post-template');
            
            if (!campingsContainer) {
                campingsContainer = document.querySelector('.gt-ws-ctv-campings-block .wp-block-post-template');
            }
            
            if (!campingsContainer) {
                // Essayer d'autres sélecteurs possibles
                campingsContainer = document.querySelector('.wp-block-query .wp-block-post-template');
            }
            
            if (!campingsContainer) {
                campingsContainer = document.querySelector('.wp-block-post-template');
            }
            
            if (!campingsContainer) {
                campingsContainer = document.querySelector('ul.wp-block-post-template');
            }
            
            if (!campingsContainer) {
                const queryBlocks = document.querySelectorAll('.wp-block-query');
                queryBlocks.forEach((block, index) => {
                });
                return;
            }
            
            
            // Afficher un indicateur de chargement
            campingsContainer.style.opacity = '0.5';
            campingsContainer.style.transition = 'opacity 0.3s ease';
            
            // Récupérer l'URL AJAX et le nonce depuis les attributs data
            const ajaxUrl = document.querySelector('[data-ajax-url]')?.getAttribute('data-ajax-url') || '/wp-admin/admin-ajax.php';
            const nonce = document.querySelector('[data-nonce]')?.getAttribute('data-nonce') || '';
            
            
            // Préparer les données pour l'AJAX
            const ajaxData = new FormData();
            ajaxData.append('action', 'gt_ws_ctv_filter_campings');
            ajaxData.append('nonce', nonce);
            ajaxData.append('region', formData.region || '');
            ajaxData.append('idCamping', formData.camping || '');
            ajaxData.append('type', formData.type || '');
            ajaxData.append('nbPers', formData.nbPers || '');
            ajaxData.append('arrival', formData.arrival || '');
            ajaxData.append('departure', formData.departure || '');
            
            // Effectuer la requête AJAX
            
            fetch(ajaxUrl, {
                method: 'POST',
                body: ajaxData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                return response.text(); // Utiliser text() d'abord pour voir le contenu brut
            })
            .then(text => {
                
                try {
                    const data = JSON.parse(text);
                    
                    if (data.success) {
                        // Filtrer les campings côté client basé sur les IDs retournés
                        const filteredIds = data.data.filtered_camping_ids;
                        
                        
                        // Trouver tous les campings dans le conteneur
                        const allCampings = campingsContainer.querySelectorAll('li');
                        
                        let visibleCount = 0;
                        
                        allCampings.forEach(camping => {
                            // Extraire l'ID du post depuis la classe CSS
                            const classMatch = camping.className.match(/post-(\d+)/);
                            
                            if (classMatch) {
                                const postId = parseInt(classMatch[1]);
                                
                                if (filteredIds.includes(postId)) {
                                    // Afficher le camping
                                    camping.style.display = '';
                                    camping.style.opacity = '1';
                                    visibleCount++;
                                } else {
                                    // Masquer le camping
                                    camping.style.display = 'none';
                                }
                            } else {
                            }
                        });
                        
                        // Restaurer l'opacité du conteneur
                        campingsContainer.style.opacity = '1';
                        
                        // Mettre à jour le compteur
                        const counter = document.querySelector('.gt-campings-count, .wp-block-query__results-count');
                        if (counter) {
                            counter.textContent = `${visibleCount} camping${visibleCount > 1 ? 's' : ''} trouvé${visibleCount > 1 ? 's' : ''}`;
                        }
                        
                        // Mettre à jour le message d'absence de résultats
                        updateNoResultsMessage(visibleCount);
                        
        // Réinitialiser les événements de hover après le filtrage
        store('gt/ctv').actions.initCampingHoverEvents();
        
        // Trier les campings par disponibilité
        store('gt/ctv').actions.sortCampingsByAvailability();
        
                    } else {
                        campingsContainer.style.opacity = '1';
                    }
                } catch (parseError) {
                    campingsContainer.style.opacity = '1';
                }
            })
            .catch(error => {
                campingsContainer.style.opacity = '1';
            });
        },
        
        // Toggle multiselect dropdown
        toggleMultiselect: (e) => {
            // Don't toggle if clicking on a tag remove button
            if (e.target.closest('.gt-campings-filtre__multiselect-tag-remove')) {
                return;
            }
            
            const context = getContext();
            const element = getElement();
            const multiselect = element.ref.closest('.gt-campings-filtre__multiselect');
            
            // Close all other multiselects first
            document.querySelectorAll('.gt-campings-filtre__multiselect').forEach(ms => {
                if (ms !== multiselect) {
                    const otherContext = ms.__wpContext || {};
                    if (otherContext.isOpen) {
                        otherContext.isOpen = false;
                    }
                }
            });
            
            context.isOpen = !context.isOpen;
            
            // Update tags
            store('gt/ctv').actions.updateMultiselectLabel(multiselect);
            
            // Close on outside click
            if (context.isOpen) {
                setTimeout(() => {
                    const handleClickOutside = (event) => {
                        if (multiselect && !multiselect.contains(event.target)) {
                            context.isOpen = false;
                            document.removeEventListener('click', handleClickOutside);
                        }
                    };
                    document.addEventListener('click', handleClickOutside);
                }, 0);
            }
        },
        
        // Toggle option in multiselect
        toggleMultiselectOption: (e) => {
            const element = getElement();
            const multiselect = element.ref.closest('.gt-campings-filtre__multiselect');
            
            // Update label
            store('gt/ctv').actions.updateMultiselectLabel(multiselect);
            
            // Run filters
            store('gt/ctv').actions.runFilters(e);
        },
        
        // Update multiselect tags
        updateMultiselectLabel: (multiselect) => {
            if (!multiselect) return;
            
            const selectedCheckboxes = multiselect.querySelectorAll('input[type="checkbox"]:checked');
            const tagsContainer = multiselect.querySelector('.gt-campings-filtre__multiselect-tags');
            const placeholder = multiselect.querySelector('.gt-campings-filtre__multiselect-placeholder');
            const button = multiselect.querySelector('.gt-campings-filtre__multiselect-button');
            
            if (!tagsContainer) return;
            
            // Remove existing tags (except placeholder)
            const existingTags = tagsContainer.querySelectorAll('.gt-campings-filtre__multiselect-tag');
            existingTags.forEach(tag => tag.remove());
            
            if (selectedCheckboxes.length === 0) {
                if (placeholder) {
                    placeholder.style.display = 'inline';
                }
                if (button) {
                    button.classList.add('is-placeholder');
                }
            } else {
                if (placeholder) {
                    placeholder.style.display = 'none';
                }
                if (button) {
                    button.classList.remove('is-placeholder');
                }
                
                // Create tags for each selected item
                selectedCheckboxes.forEach(checkbox => {
                    const label = checkbox.closest('label');
                    if (!label) return;
                    
                    // Get text content
                    const textNodes = Array.from(label.childNodes)
                        .filter(node => node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'INPUT'))
                        .map(node => node.textContent.trim())
                        .filter(text => text)
                        .join(' ');
                    
                    if (!textNodes) return;
                    
                    // Create tag element
                    const tag = document.createElement('span');
                    tag.className = 'gt-campings-filtre__multiselect-tag';
                    tag.setAttribute('data-value', checkbox.value);
                    
                    const tagText = document.createElement('span');
                    tagText.className = 'gt-campings-filtre__multiselect-tag-text';
                    tagText.textContent = textNodes;
                    
                    const tagRemove = document.createElement('span');
                    tagRemove.className = 'gt-campings-filtre__multiselect-tag-remove';
                    tagRemove.textContent = '×';
                    tagRemove.style.cursor = 'pointer';
                    tagRemove.addEventListener('click', (e) => {
                        e.stopPropagation();
                        store('gt/ctv').actions.removeMultiselectTag(e, checkbox.value, multiselect);
                    });
                    
                    tag.appendChild(tagText);
                    tag.appendChild(tagRemove);
                    
                    // Insert before placeholder or arrow
                    if (placeholder) {
                        tagsContainer.insertBefore(tag, placeholder);
                    } else {
                        tagsContainer.appendChild(tag);
                    }
                });
            }
        },
        
        // Remove tag from multiselect
        removeMultiselectTag: (e, value, multiselect) => {
            if (e) {
                e.stopPropagation(); // Prevent dropdown from opening
            }
            
            // If multiselect is not provided, try to find it from the event
            if (!multiselect && e) {
                const tag = e.target.closest('.gt-campings-filtre__multiselect-tag');
                if (tag) {
                    multiselect = tag.closest('.gt-campings-filtre__multiselect');
                    if (!value) {
                        value = tag.getAttribute('data-value');
                    }
                }
            }
            
            if (!multiselect || !value) return;
            
            const checkbox = multiselect.querySelector(`input[type="checkbox"][value="${value}"]`);
            
            if (checkbox) {
                checkbox.checked = false;
                // Update tags
                store('gt/ctv').actions.updateMultiselectLabel(multiselect);
                // Run filters
                store('gt/ctv').actions.runFilters({ target: checkbox, type: 'change' });
            }
        },
        
        // Fonction pour trier les campings par disponibilité
        sortCampingsByAvailability: () => {
            // Chercher le conteneur de campings (plusieurs sélecteurs possibles)
            let campingsContainer = document.querySelector('.wp-block-query[data-namespace="gt-ws-ctv-campings"] .wp-block-post-template');
            
            if (!campingsContainer) {
                campingsContainer = document.querySelector('.gt-ws-ctv-campings-block .wp-block-post-template');
            }
            
            if (!campingsContainer) {
                // Essayer d'autres sélecteurs pour la page de liste
                campingsContainer = document.querySelector('.wp-block-post-template');
            }
            
            if (!campingsContainer) {
                // Chercher dans les éléments de liste
                campingsContainer = document.querySelector('ul.wp-block-post-template');
            }
            
            if (!campingsContainer) {
                return;
            }
            
            const campings = Array.from(campingsContainer.querySelectorAll('li'));
            
            if (campings.length === 0) {
                return;
            }
            
            // Trier les campings par disponibilité
            campings.sort((a, b) => {
                // Récupérer le statut de disponibilité de chaque camping
                const aStatus = getCampingAvailabilityStatus(a);
                const bStatus = getCampingAvailabilityStatus(b);
                
                
                // Définir l'ordre de priorité
                const statusOrder = {
                    'disponible': 1,
                    'contreproposition': 2,
                    'indisponible': 3
                };
                
                const aOrder = statusOrder[aStatus] || 3;
                const bOrder = statusOrder[bStatus] || 3;
                
                // Si même statut, trier par nom
                if (aOrder === bOrder) {
                    const aName = a.querySelector('.wp-block-post-title')?.textContent || '';
                    const bName = b.querySelector('.wp-block-post-title')?.textContent || '';
                    return aName.localeCompare(bName);
                }
                
                return aOrder - bOrder;
            });
            
            // Réorganiser les éléments dans le DOM
            const fragment = document.createDocumentFragment();
            campings.forEach(camping => {
                fragment.appendChild(camping);
            });
            campingsContainer.appendChild(fragment);
            
        }
    }
});

// Fonction pour déterminer le statut de disponibilité d'un camping
function getCampingAvailabilityStatus(campingElement) {
    // Pour la page de liste des campings, on va utiliser une logique différente
    
    // Chercher les blocs de disponibilité dans le camping
    const disponibilitesBlocks = campingElement.querySelectorAll('.wp-block-gt-gt-ws-ctv-disponibilites');
    
    if (disponibilitesBlocks.length > 0) {
        // Vérifier le statut de chaque bloc de disponibilité
        for (const block of disponibilitesBlocks) {
            const statut = block.getAttribute('data-gt-statut');
            if (statut) {
                return statut;
            }
        }
    }
    
    // Si aucun bloc de disponibilité, chercher dans les éléments enfants
    const statutElements = campingElement.querySelectorAll('[data-gt-statut]');
    for (const element of statutElements) {
        const statut = element.getAttribute('data-gt-statut');
        if (statut) {
            return statut;
        }
    }
    
    // Pour la page de liste, utiliser une logique basée sur les prix
    const priceElement = campingElement.querySelector('.gt-ws-ctv-data-price, [data-gt-price]');
    if (priceElement) {
        const price = parseFloat(priceElement.textContent || priceElement.getAttribute('data-gt-price') || '0');
        if (price > 0) {
            return 'disponible';
        }
    }
    
    // Chercher des indicateurs de disponibilité dans le texte
    const campingText = campingElement.textContent.toLowerCase();
    if (campingText.includes('disponible') || campingText.includes('à partir de')) {
        return 'disponible';
    }
    
    if (campingText.includes('complet') || campingText.includes('indisponible')) {
        return 'indisponible';
    }
    
    return 'indisponible';
}

// Fonction pour ajouter les attributs data-gt-department et data-gt-criterion aux éléments <li> si ils ne sont pas présents
function addDepartmentAttributesToCampings() {
    // Trouver tous les éléments <li> qui représentent des campings
    const campingItems = document.querySelectorAll('li.wp-block-post[class*="post-"], li[class*="post-"][class*="camping"], li[class*="post-"][class*="type-camping"]');
    
    if (campingItems.length === 0) {
        console.log('GT-WS-CTV: Aucun élément camping trouvé');
        return;
    }
    
    
    // Récupérer les IDs des posts depuis les classes
    const postIds = [];
    campingItems.forEach(item => {
        const classMatch = item.className.match(/\bpost-(\d+)\b/);
        if (classMatch) {
            const postId = parseInt(classMatch[1]);
            if (postId && !postIds.includes(postId)) {
                postIds.push(postId);
            }
        }
    });
    
    if (postIds.length === 0) {
        console.log('GT-WS-CTV: Aucun post ID trouvé');
        return;
    }
    
    
    // Récupérer les données via l'API REST WordPress
    const restUrl = '/wp-json/wp/v2/camping?include=' + postIds.join(',') + '&per_page=100';
    
    fetch(restUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error('Erreur API REST: ' + response.status);
            }
            return response.json();
        })
        .then(campings => {
            
            campings.forEach(camping => {
                if (!camping || !camping.id) return;
                
                const postId = camping.id;
                const department = camping.meta?.gt_ws_ctv_camping_department || '';
                const features = camping.meta?.gt_ws_ctv_camping_features;
                
                // Trouver tous les éléments <li> correspondant à ce post
                const items = document.querySelectorAll(`li[class*="post-${postId}"]`);
                
                if (items.length === 0) {
                    console.warn('GT-WS-CTV: Aucun élément <li> trouvé pour le camping ID ' + postId);
                    return;
                }
                
                items.forEach(item => {
                    // Ajouter l'attribut data-gt-department
                    if (!item.hasAttribute('data-gt-department')) {
                        item.setAttribute('data-gt-department', department || '');
                    }
                    
                    // Ajouter aussi les autres attributs s'ils manquent
                    if (!item.hasAttribute('data-gt-camping') && camping.meta?.gt_ws_ctv_campingKey) {
                        item.setAttribute('data-gt-camping', camping.meta.gt_ws_ctv_campingKey);
                    }
                    if (!item.hasAttribute('data-region') && camping.meta?.gt_ws_ctv_camping_region) {
                        item.setAttribute('data-region', camping.meta.gt_ws_ctv_camping_region);
                    }
                    if (!item.hasAttribute('data-gt-etoiles') && camping.meta?.gt_ws_ctv_camping_etoiles) {
                        item.setAttribute('data-gt-etoiles', camping.meta.gt_ws_ctv_camping_etoiles);
                    }
                    
                    // Ajouter l'attribut data-gt-criterion avec seulement les myKey de piscine
                    if (!item.hasAttribute('data-gt-criterion') && features) {
                        try {
                            // Liste des myKey de piscine, services et activités à chercher
                            const piscineKeys = ['29353', '29351', '29364', '29356', '27760', '27759', '27818', '27761', '27603', '27526', '26663', '27871', '27899', '27863', '29431'];
                            const piscineMyKeys = [];
                            
                            // Fonction récursive pour extraire les myKey de piscine
                            // Pour les clés de piscine et 27818, accepter même sans HasValue=true
                            const piscineKeysSpecial = ['29353', '29351', '29364', '29356', '27818'];
                            const extractPiscineCriteria = (data) => {
                                if (Array.isArray(data)) {
                                    data.forEach(featureItem => {
                                        if (featureItem && typeof featureItem === 'object') {
                                            if (featureItem.myKey) {
                                                const mykey = String(featureItem.myKey);
                                                // Vérifier si c'est un myKey de piscine
                                                if (piscineKeys.includes(mykey)) {
                                                    const hasValue = featureItem.HasValue === true || featureItem.HasValue === 1 || featureItem.HasValue === '1' || featureItem.HasValue === 'true';
                                                    
                                                    // IMPORTANT: Pour TOUTES les clés (piscine et épicerie), EXIGER HasValue=true pour éviter d'extraire des références générales
                                                    let shouldAdd = false;
                                                    if (hasValue) {
                                                        shouldAdd = true;
                                                    } else {
                                                        // Pour TOUTES les clés, EXIGER HasValue=true
                                                        shouldAdd = false;
                                                    }
                                                    
                                                    if (shouldAdd && !piscineMyKeys.includes(mykey)) {
                                                        piscineMyKeys.push(mykey);
                                                        const type = piscineKeysSpecial.includes(mykey) ? (mykey === '27818' ? 'Épicerie' : 'Piscine') : 'Autre';
                                                        
                                                    }
                                                }
                                            }
                                            
                                            // Recherche récursive dans mySubItems
                                            if (featureItem.mySubItems && Array.isArray(featureItem.mySubItems)) {
                                                extractPiscineCriteria(featureItem.mySubItems);
                                            }
                                            
                                            // Recherche récursive dans myFeatures (pour les objets comme "Piscine" dans Infrastructure)
                                            // Structure: Infrastructure > Piscine > myEntities > myFeatures > mySubItems
                                            if (featureItem.myFeatures) {
                                                // Si myFeatures a mySubItems, explorer directement mySubItems
                                                if (featureItem.myFeatures.mySubItems && (Array.isArray(featureItem.myFeatures.mySubItems) || typeof featureItem.myFeatures.mySubItems === 'object')) {
                                                    extractPiscineCriteria(featureItem.myFeatures.mySubItems);
                                                } else {
                                                    // Sinon, explorer myFeatures récursivement
                                                    extractPiscineCriteria(featureItem.myFeatures);
                                                }
                                            }
                                            
                                            // Recherche récursive dans myEntities (structure plus profonde)
                                            if (featureItem.myEntities && (Array.isArray(featureItem.myEntities) || typeof featureItem.myEntities === 'object')) {
                                                extractPiscineCriteria(featureItem.myEntities);
                                            }
                                        }
                                    });
                                } else if (data && typeof data === 'object') {
                                    if (data.myKey) {
                                        const mykey = String(data.myKey);
                                        if (piscineKeys.includes(mykey)) {
                                            const hasValue = data.HasValue === true || data.HasValue === 1 || data.HasValue === '1' || data.HasValue === 'true';
                                            
                                            // IMPORTANT: Pour TOUTES les clés (piscine et épicerie), EXIGER HasValue=true pour éviter d'extraire des références générales
                                            let shouldAdd = false;
                                            if (hasValue) {
                                                shouldAdd = true;
                                            } else {
                                                // Pour TOUTES les clés, EXIGER HasValue=true
                                                shouldAdd = false;
                                            }
                                            
                                            if (shouldAdd && !piscineMyKeys.includes(mykey)) {
                                                piscineMyKeys.push(mykey);
                                                const type = piscineKeysSpecial.includes(mykey) ? (mykey === '27818' ? 'Épicerie' : 'Piscine') : 'Autre';
                                               
                                            }
                                        }
                                    }
                                    
                                    if (data.mySubItems && Array.isArray(data.mySubItems)) {
                                        extractPiscineCriteria(data.mySubItems);
                                    }
                                    
                                    // Recherche récursive dans myFeatures (pour les objets comme "Piscine" dans Infrastructure)
                                    if (data.myFeatures) {
                                        // Si myFeatures a mySubItems, explorer directement mySubItems
                                        if (data.myFeatures.mySubItems && (Array.isArray(data.myFeatures.mySubItems) || typeof data.myFeatures.mySubItems === 'object')) {
                                            extractPiscineCriteria(data.myFeatures.mySubItems);
                                        } else {
                                            // Sinon, explorer myFeatures récursivement
                                            extractPiscineCriteria(data.myFeatures);
                                        }
                                    }
                                    
                                    // Recherche récursive dans myEntities (structure plus profonde)
                                    if (data.myEntities && (Array.isArray(data.myEntities) || typeof data.myEntities === 'object')) {
                                        extractPiscineCriteria(data.myEntities);
                                    }
                                }
                            };
                            
                            // Parser les features si c'est une chaîne JSON
                            let featuresData = features;
                            if (typeof featuresData === 'string') {
                                try {
                                    featuresData = JSON.parse(featuresData);
                                } catch (e) {
                                    console.warn('GT-WS-CTV: Erreur parsing features pour camping ' + postId, e);
                                    featuresData = null;
                                }
                            }
                            
                            if (featuresData) {
                                extractPiscineCriteria(featuresData);
                            }
                            
                            // Ajouter l'attribut data-gt-criterion avec les myKey trouvés
                            // IMPORTANT: Ne pas écraser l'attribut PHP s'il existe déjà et contient des données
                            const existingCriterion = item.getAttribute('data-gt-criterion');
                            const criterionJson = JSON.stringify(piscineMyKeys);
                            
                            // Si l'attribut PHP existe déjà et contient des données, ne pas l'écraser
                            // Fusionner les clés si nécessaire pour ne pas perdre les données PHP
                            if (existingCriterion && existingCriterion !== '[]') {
                                try {
                                    const existingKeys = JSON.parse(existingCriterion);
                                    if (Array.isArray(existingKeys) && existingKeys.length > 0) {
                                        // L'attribut PHP contient déjà des données, ne pas l'écraser
                                        return; // Ne pas écraser l'attribut PHP
                                    }
                                } catch (e) {
                                    // Si erreur de parsing, garder l'existant
                                    console.warn('GT-WS-CTV: Erreur parsing existingCriterion pour camping ' + postId, e);
                                    return; // Ne pas écraser l'attribut PHP en cas d'erreur
                                }
                            }
                            
                            // Si pas d'attribut existant ou vide, ajouter les nouvelles clés
                            item.setAttribute('data-gt-criterion', criterionJson);
                           
                        } catch (e) {
                            // Ajouter un tableau vide en cas d'erreur
                            item.setAttribute('data-gt-criterion', '[]');
                        }
                    }
                });
            });
            
            
            // Une fois les attributs ajoutés, déclencher le filtrage si nécessaire
            if (store('gt/ctv')?.actions?.runFilters) {
                // Vérifier s'il y a des filtres actifs
                const activeFilters = document.querySelectorAll('.gt-campings-filtre input:checked:not([value=""])');
                if (activeFilters.length > 0) {
                    store('gt/ctv').actions.runFilters();
                }
            }
        })
        .catch(error => {
            console.error('GT-WS-CTV: Erreur lors de la récupération des données:', error);
        });
}

// Fonction pour ajouter les attributs piscine immédiatement via endpoint REST personnalisé
function addPiscineAttributesImmediately() {
    
    // Trouver tous les éléments <li> qui représentent des campings
    const campingItems = document.querySelectorAll('li[class*="post-"]');
    
    if (campingItems.length === 0) {
        return;
    }
    
    
    // Récupérer les IDs des posts depuis les classes
    const postIds = [];
    campingItems.forEach(item => {
        const classMatch = item.className.match(/\bpost-(\d+)\b/);
        if (classMatch) {
            const postId = parseInt(classMatch[1]);
            if (postId && !postIds.includes(postId)) {
                postIds.push(postId);
            }
        }
    });
    
    if (postIds.length === 0) {
        return;
    }
    
    
    // Utiliser l'endpoint REST personnalisé
    const restUrl = '/wp-json/gt-ws-ctv/v1/piscine-criteria?ids=' + postIds.join(',');
    
    fetch(restUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error('Erreur API REST: ' + response.status);
            }
            return response.json();
        })
        .then(results => {
            
            // Parcourir les résultats et ajouter les attributs
            Object.keys(results).forEach(postIdStr => {
                const postId = parseInt(postIdStr);
                const piscineMyKeys = results[postIdStr] || [];
                
                // Trouver tous les éléments <li> correspondant à ce post
                const items = document.querySelectorAll(`li[class*="post-${postId}"]`);
                
                if (items.length === 0) {
                    console.warn('GT-WS-CTV: Aucun élément <li> trouvé pour le camping ID ' + postId);
                    return;
                }
                
                items.forEach(item => {
                    // IMPORTANT: Ne JAMAIS écraser l'attribut PHP s'il existe déjà et contient des données
                    const existingCriterion = item.getAttribute('data-gt-criterion');
                    
                    // Si l'attribut PHP existe déjà et contient des données, ne pas l'écraser
                    if (existingCriterion && existingCriterion !== '[]') {
                        try {
                            const existingKeys = JSON.parse(existingCriterion);
                            if (Array.isArray(existingKeys) && existingKeys.length > 0) {
                                // L'attribut PHP contient déjà des données, ne pas l'écraser
                                console.log('GT-WS-CTV: Attribut PHP existant pour camping ' + postId + ' - Ne pas écraser: ' + existingCriterion);
                                return; // Ne pas écraser l'attribut PHP
                            }
                        } catch (e) {
                            // Si erreur de parsing, garder l'existant
                            console.warn('GT-WS-CTV: Erreur parsing existingCriterion pour camping ' + postId, e);
                            return;
                        }
                    }
                    
                    // Si pas d'attribut existant ou vide, ajouter les nouvelles clés
                    const criterionJson = JSON.stringify(piscineMyKeys);
                    item.setAttribute('data-gt-criterion', criterionJson);
                    
                   
                });
            });
            
            
            // Une fois les attributs ajoutés, déclencher le filtrage si nécessaire
            if (store('gt/ctv')?.actions?.runFilters) {
                const activeFilters = document.querySelectorAll('.gt-campings-filtre input:checked:not([value=""])');
                if (activeFilters.length > 0) {
                    store('gt/ctv').actions.runFilters();
                }
            }
        })
        .catch(error => {
            console.error('GT-WS-CTV: ❌ Erreur lors de la récupération des critères piscine:', error);
        });
}

// Trier les campings au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
    // Attendre un peu que les éléments soient chargés
    setTimeout(() => {
        store('gt/ctv').actions.sortCampingsByAvailability();
        
        // Ajouter les attributs data-gt-department si ils ne sont pas présents
        addDepartmentAttributesToCampings();
        
        // Ajouter les attributs piscine immédiatement
        addPiscineAttributesImmediately();
    }, 1000);
    
    // Réessayer après un délai supplémentaire au cas où le contenu serait chargé dynamiquement
    setTimeout(() => {
        addDepartmentAttributesToCampings();
        addPiscineAttributesImmediately();
    }, 2000);
    
    // Réessayer encore une fois après 3 secondes
    setTimeout(() => {
        addPiscineAttributesImmediately();
    }, 3000);
});

// Observer les changements dans le DOM pour ajouter les attributs aux nouveaux éléments chargés
if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
        let shouldAddAttributes = false;
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Element node
                        if (node.tagName === 'LI' && node.className && node.className.includes('post-') && !node.hasAttribute('data-gt-department')) {
                            shouldAddAttributes = true;
                        } else if (node.querySelectorAll && node.querySelectorAll('li[class*="post-"]:not([data-gt-department])').length > 0) {
                            shouldAddAttributes = true;
                        }
                    }
                });
            }
        });
        
        if (shouldAddAttributes) {
            setTimeout(() => {
                addDepartmentAttributesToCampings();
            }, 100);
        }
    });
    
    // Observer le conteneur des campings
    document.addEventListener('DOMContentLoaded', () => {
        const campingsContainer = document.querySelector('.wp-block-query[data-namespace="gt-ws-ctv-campings"], .wp-block-post-template, .gt-ws-ctv-campings-block');
        if (campingsContainer) {
            observer.observe(campingsContainer, {
                childList: true,
                subtree: true
            });
        }
    });
}


